(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5gIXE", function(module, exports) {
$parcel$export(module.exports, "WidgetLoadingState", function () { return (parcelRequire("8Z9am")).WidgetLoadingState; });
parcelRequire("8Z9am");

});
parcelRegister("8Z9am", function(module, exports) {

$parcel$export(module.exports, "WidgetLoadingState", function () { return $2f7c9efe28896a0b$export$7e27a2e8e18ffe9b; });

var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $bLjZo = parcelRequire("bLjZo");
const $2f7c9efe28896a0b$var$Header = (0, $avNx5.default).div`
    width: 30%;
    height: 30px;
    border-radius: 8px;
`;
const $2f7c9efe28896a0b$var$Content = (0, $avNx5.default).div`
    height: ${({ height: height })=>height ?? "100px"};
    border-radius: 8px;
`;
const $2f7c9efe28896a0b$var$Button = (0, $avNx5.default).div`
    width: 130px;
    height: 40px;
    border-radius: 16px;
    &.sm {
        height: 30px;
    }
`;
const $2f7c9efe28896a0b$export$7e27a2e8e18ffe9b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).memo(function WidgetLoadingState({ title: title, headerButton: headerButton, height: height }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bLjZo.WidgetLayout), {
        "data-testid": "widgetLoadingState",
        title: title ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($2f7c9efe28896a0b$var$Header, {
            className: "shimmer-container"
        }),
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($2f7c9efe28896a0b$var$Button, {
            className: "shimmer-container"
        }),
        ...headerButton && {
            headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($2f7c9efe28896a0b$var$Button, {
                className: "shimmer-container sm"
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($2f7c9efe28896a0b$var$Content, {
        className: "shimmer-container",
        height: height
    }));
});

});


parcelRegister("iqDzt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e1eb12281409d6c$export$2e2bcd8739ae039; });

var $jGnJo = parcelRequire("jGnJo");
function $4e1eb12281409d6c$export$2e2bcd8739ae039(callback, delay, runOnInit) {
    const savedCallback = (0, $jGnJo.useRef)();
    (0, $jGnJo.useEffect)(()=>{
        savedCallback.current = callback;
    });
    (0, $jGnJo.useEffect)(()=>{
        function tick() {
            if (typeof savedCallback.current === "function") savedCallback.current();
        }
        if (runOnInit) tick();
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>{
                clearInterval(id);
            };
        }
    }, [
        delay,
        runOnInit
    ]);
}

});

parcelRegister("ioU8h", function(module, exports) {
$parcel$export(module.exports, "Alert", function () { return (parcelRequire("5G3y7")).Alert; });
parcelRequire("5G3y7");

});
parcelRegister("5G3y7", function(module, exports) {

$parcel$export(module.exports, "Alert", function () { return $d2cfcbdf1febfe1e$export$caec2af78bcc877f; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");
const $d2cfcbdf1febfe1e$var$SAlert = (0, $avNx5.default).div`
    color: ${({ theme: theme })=>theme.font.darkestColor};
    background-color: ${({ theme: theme, error: error })=>error ? theme.brandColors.CA_Light_Coral : theme.brandColors.CA_Light_Green};
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 8px;
`;
function $d2cfcbdf1febfe1e$export$caec2af78bcc877f({ dataTestId: dataTestId, className: className, style: style, error: error, message: message }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($d2cfcbdf1febfe1e$var$SAlert, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        error: error,
        "data-testid": dataTestId ?? "alert-" + (error ? "error" : "success")
    }, message);
}

});



var $jGnJo = parcelRequire("jGnJo");

var $gOtN5 = parcelRequire("gOtN5");

var $gCMx8 = parcelRequire("gCMx8");

var $e19ko = parcelRequire("e19ko");

var $bvuBe = parcelRequire("bvuBe");

var $fuAgC = parcelRequire("fuAgC");

var $9VxWA = parcelRequire("9VxWA");

var $iD0nF = parcelRequire("iD0nF");

var $4wzzF = parcelRequire("4wzzF");

var $7CxMf = parcelRequire("7CxMf");

var $4Fcjx = parcelRequire("4Fcjx");
var $4IDUs = parcelRequire("4IDUs");

var $gaM68 = parcelRequire("gaM68");

var $esLNt = parcelRequire("esLNt");

var $2zmkm = parcelRequire("2zmkm");

var $5DNxz = parcelRequire("5DNxz");

var $7dhC8 = parcelRequire("7dhC8");
const $628b115dc3c73abd$var$createRootReducers = ()=>{
    const rootReducerFn = (0, $4Fcjx.combineReducers)({
        entitlements: (0, $2zmkm.default),
        portalSessionReset: (0, $5DNxz.default),
        user: (0, $7dhC8.default),
        [(0, $esLNt.enhancedApi).reducerPath]: (0, $esLNt.enhancedApi).reducer
    });
    return (state, action)=>{
        return rootReducerFn((0, $7dhC8.reset) && action.type === (0, $7dhC8.reset).type ? undefined : state, action);
    };
};
const $628b115dc3c73abd$export$6f57813fe9f31bf9 = (0, $4IDUs.configureStore)({
    reducer: $628b115dc3c73abd$var$createRootReducers(),
    devTools: false,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat([
            (0, $esLNt.enhancedApi).middleware
        ])
});
(0, $gaM68.setupListeners)($628b115dc3c73abd$export$6f57813fe9f31bf9.dispatch);
const $628b115dc3c73abd$export$1b3de3898efde2ba = (preloadedState)=>{
    return (0, $4IDUs.configureStore)({
        reducer: $628b115dc3c73abd$var$createRootReducers(),
        preloadedState: preloadedState,
        devTools: false,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat([
                (0, $esLNt.enhancedApi).middleware
            ])
    });
};



var $jGnJo = parcelRequire("jGnJo");

var $5Lxn9 = parcelRequire("5Lxn9");
var $gCMx8 = parcelRequire("gCMx8");

var $4Mpw9 = parcelRequire("4Mpw9");

var $5Qy4z = parcelRequire("5Qy4z");

var $f3Zjn = parcelRequire("f3Zjn");

var $8JDp9 = parcelRequire("8JDp9");

var $6jyTD = parcelRequire("6jyTD");

var $9MNgB = parcelRequire("9MNgB");

var $8UPmf = parcelRequire("8UPmf");

var $jGnJo = parcelRequire("jGnJo");

var $hjsTS = parcelRequire("hjsTS");

var $e19ko = parcelRequire("e19ko");

var $gCMx8 = parcelRequire("gCMx8");

var $2p1p9 = parcelRequire("2p1p9");

var $j7d1a = parcelRequire("j7d1a");

var $a3vgd = parcelRequire("a3vgd");

var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $g1rJs = parcelRequire("g1rJs");

var $fzqPg = parcelRequire("fzqPg");

var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $lIzCm = parcelRequire("lIzCm");

var $g7ZMG = parcelRequire("g7ZMG");
const $b0c17c8e9c707500$var$Wrapper = (0, $avNx5.default).div`
    display: flex;
    gap: 4px;
    width: 32px;
`;
function $b0c17c8e9c707500$export$8df3070cb8568cb1({ chargingSession: chargingSession }) {
    const adaptConnectorNaming = (0, $lIzCm.useAdaptConnectorNaming)();
    if (chargingSession.productId && chargingSession.productId < 4) {
        if (chargingSession.connectorFunctionType === "Charger") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
            className: "fa fa-car",
            title: adaptConnectorNaming(chargingSession?.connectorName ?? "")
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
            className: "fa icon-socket",
            title: adaptConnectorNaming(chargingSession?.connectorName ?? "")
        });
    }
    if ((0, $g7ZMG.default)(chargingSession)) {
        if (chargingSession.connectorId === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b0c17c8e9c707500$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
            className: "fa fa-circle",
            title: adaptConnectorNaming(chargingSession?.connectorName ?? ""),
            "data-testid": "leftConnector"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
            className: "fa fa-circle-o"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b0c17c8e9c707500$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
            className: "fa fa-circle-o"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
            className: "fa fa-circle",
            title: adaptConnectorNaming(chargingSession?.connectorName ?? ""),
            "data-testid": "rightConnector"
        }));
    }
    if (chargingSession.productId === 7) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
        className: "fa fa-car",
        title: adaptConnectorNaming(chargingSession?.connectorName ?? "")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        "data-testid": "emptyDiv"
    });
}





var $dwv4x = parcelRequire("dwv4x");

var $bLjZo = parcelRequire("bLjZo");

var $d0j3t = parcelRequire("d0j3t");

var $1IbJL = parcelRequire("1IbJL");
const $96e348eb88b13195$var$THead = (0, $avNx5.default).thead`
    height: 40px;
`;
const $96e348eb88b13195$var$TTitle = (0, $avNx5.default).th`
    font-size: 14px;
`;
const $96e348eb88b13195$var$ButtonContainer = (0, $avNx5.default).div`
    display: flex;
    width: inherit;
    align-items: center;
    justify-content: center;
`;
const $96e348eb88b13195$export$c9346c8390d51ce8 = 10;
function $96e348eb88b13195$export$d96ee243323785bc({ sessions: sessions, loadMoreChargingSessions: loadMoreChargingSessions, loading: loading, showEndTime: showEndTime }) {
    const text = (0, $1IbJL.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bLjZo.WidgetLayout), {
        title: text("lblMyLatestChargingSessionsWidget"),
        "data-testid": "latest-charging-session"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "table-container",
        "data-testid": "chargingSessionContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("table", {
        className: "table table-striped table-hover"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($96e348eb88b13195$var$THead, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($96e348eb88b13195$var$TTitle, {
        className: "heading5",
        "data-testid": "row-charger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblCharger"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($96e348eb88b13195$var$TTitle, {
        className: "heading5",
        "data-testid": "row-socket"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblSocket"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($96e348eb88b13195$var$TTitle, {
        className: "heading5",
        "data-testid": "row-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblStart"
    })), showEndTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($96e348eb88b13195$var$TTitle, {
        className: "heading5",
        "data-testid": "row-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblStop"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($96e348eb88b13195$var$TTitle, {
        className: "heading5",
        "data-testid": "row-total"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblTotalKWh"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("tbody", null, sessions?.map((session, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("tr", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("td", {
            className: "text5",
            "data-testid": `name-${i}`
        }, session.chargePointName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("td", {
            className: "text5",
            "data-testid": `icons-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $b0c17c8e9c707500$export$8df3070cb8568cb1), {
            chargingSession: session
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("td", {
            className: "text5",
            "data-testid": `startTime-${i}`
        }, (0, $dwv4x.dateLocalize)(session.startTime)), showEndTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("td", {
            className: "text5",
            "data-testid": `endTime-${i}`
        }, (0, $dwv4x.dateLocalize)(session.endTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("td", {
            className: "text5",
            "data-testid": `totalKwH-${i}`
        }, session?.totalConsumptionKwh?.toFixed(3))))))), loadMoreChargingSessions && (0, $d0j3t.isMoreItemsToLoad)($96e348eb88b13195$export$c9346c8390d51ce8, sessions.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($96e348eb88b13195$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        label: text("btnLoadMore"),
        icon: "pi pi-chevron-down",
        iconPos: "right",
        onClick: ()=>loadMoreChargingSessions(),
        loading: loading
    })));
}





var $2GMY2 = parcelRequire("2GMY2");

var $9Rt6A = parcelRequire("9Rt6A");

var $2EXu7 = parcelRequire("2EXu7");

var $5LXeP = parcelRequire("5LXeP");

var $9BVHD = parcelRequire("9BVHD");

var $eW4Jt = parcelRequire("eW4Jt");

var $l0Y5b = parcelRequire("l0Y5b");
parcelRequire("5gIXE");
var $8Z9am = parcelRequire("8Z9am");

var $iqDzt = parcelRequire("iqDzt");

var $bD3O1 = parcelRequire("bD3O1");

var $7Q01G = parcelRequire("7Q01G");

var $3O3iR = parcelRequire("3O3iR");

var $1IbJL = parcelRequire("1IbJL");

var $93hlo = parcelRequire("93hlo");

var $g7ZMG = parcelRequire("g7ZMG");

var $61HZy = parcelRequire("61HZy");

var $bmUtn = parcelRequire("bmUtn");

var $cEkC2 = parcelRequire("cEkC2");

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $g1rJs = parcelRequire("g1rJs");

var $fzqPg = parcelRequire("fzqPg");

var $6SGzc = parcelRequire("6SGzc");

var $bD3O1 = parcelRequire("bD3O1");

var $1IbJL = parcelRequire("1IbJL");

var $ijzRR = parcelRequire("ijzRR");
const $103c66ce6c3e5a3f$var$getGreenChargingAppLink = ()=>{
    const language = (0, $bD3O1.default).getItem("userLocale");
    const notLocalized = [
        "en",
        "fr",
        "nl",
        "es",
        "pt"
    ];
    if (!language || notLocalized.includes(language.toString())) return "https://www.chargeamps.com/chargeamps-app/";
    return `https://www.chargeamps.com/${language}/chargeamps-app/`;
};
function $103c66ce6c3e5a3f$export$75ed7dfd858fd56a({ visible: visible, className: className, style: style, close: close, onAccept: onAccept }) {
    const text = (0, $1IbJL.default)();
    const handleClose = ()=>{
        close();
        onAccept();
    };
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        label: text("btnClose"),
        type: "button",
        onClick: handleClose,
        "data-testid": "green-charging-close"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $ijzRR.Dialog), {
        visible: visible,
        onHide: handleClose,
        header: text("lblGreenChargingDialogTitle"),
        footer: footer,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        "data-testid": "green-charging-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex flex-column align-items-center gap-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6SGzc.GreenChargingIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "w-full max-w-22rem text-center line-height-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgGreenChargingDialogDescription",
        values: {
            link: {
                href: $103c66ce6c3e5a3f$var$getGreenChargingAppLink(),
                target: "_blank",
                rel: "noopener noreferrer"
            }
        }
    }))));
}




function $ff0438a390809e1d$export$ab6746011d315456() {
    const text = (0, $1IbJL.default)();
    const navigate = (0, $gCMx8.useNavigate)();
    const user = (0, $e19ko.useSelector)((state)=>state.user);
    /*************/ /** States  **/ /*************/ const [showGreenChargingDialog, setShowGreenChargingDialog] = (0, $jGnJo.useState)(false);
    const [chargePointIds, setChargePointIds] = (0, $jGnJo.useState)([]);
    const [auraChargePoints, setAuraChargePoints] = (0, $jGnJo.useState)([]);
    const [haloChargePoints, setHaloChargePoints] = (0, $jGnJo.useState)([]);
    const [dawnChargePoints, setDawnChargePoints] = (0, $jGnJo.useState)([]);
    const [lunaChargePoints, setLunaChargePoints] = (0, $jGnJo.useState)([]);
    const [allReadOnly, setAllReadOnly] = (0, $jGnJo.useState)(false);
    /*************/ /** Request **/ /*************/ /** Get user statistics **/ const { data: userStatistics } = (0, $2GMY2.useStatisticsGetUserUsageStatisticsQuery)({
        userId: user.id
    }, {
        skip: !user.id
    });
    /*************************/ /** Get charging sessions **/ const { data: chargingSessions, isLoading: chargingSessionLoading } = (0, $2GMY2.useChargingSessionGetChargingSessionsForCurrentUserQuery)({
        noOfItems: 7
    }, {
        skip: !user.id
    });
    /**************************/ const [getChargePoints, { data: chargePoints, isSuccess: isSuccess, isLoading: isLoading }] = (0, $2GMY2.useLazyUserGetOwnedChargePointsWithIdsQuery)();
    const [updateUserGreenChargingSetting] = (0, $2GMY2.useUserUpdateUserGreenChargingSettingMutation)();
    (0, $jGnJo.useEffect)(()=>{
        if (isSuccess && chargePoints) {
            const chargePointIds = chargePoints.map((nextChargePoint)=>{
                return nextChargePoint?.id;
            });
            setChargePointIds(chargePointIds);
            if (!chargePointIds) navigate("/registerchargepoint");
            else {
                if ((0, $bD3O1.default).getItem("showGreenChargingModal")) setShowGreenChargingDialog(true);
                if (chargePoints) setAllReadOnly(chargePoints.find((cp)=>cp.ownerReadOnly === false) ? false : true);
                const auraChargePoints = chargePoints.filter((c)=>(0, $g7ZMG.default)(c));
                setAuraChargePoints(auraChargePoints);
                const haloChargePoints = chargePoints.filter((c)=>(0, $61HZy.default)(c));
                setHaloChargePoints(haloChargePoints);
                const dawnChargePoints = chargePoints.filter((c)=>(0, $bmUtn.default)(c));
                setDawnChargePoints(dawnChargePoints);
                const lunaChargePoints = chargePoints.filter((c)=>(0, $cEkC2.default)(c));
                setLunaChargePoints(lunaChargePoints);
            }
        }
    }, [
        isSuccess,
        chargePoints,
        navigate
    ]);
    /**************************/ /** Hide Green Charging Dialog **/ const setInformed = ()=>{
        if (user.id) updateUserGreenChargingSetting({
            userId: user.id
        });
        (0, $bD3O1.default).removeItem("showGreenChargingModal");
    };
    /********************************/ (0, $iqDzt.default)(async ()=>{
        await getChargePoints({
            body: chargePointIds,
            expand: `${(0, $j7d1a.default).OcppConfig},${(0, $j7d1a.default).TopChargingLimitation}`
        });
    }, (0, $9Rt6A.CHARGE_POINT_REFRESH_TIMEOUT) * 2, true);
    const isDesktopScreen = (0, $hjsTS.useMediaPredicate)("(min-width: 900px)");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
        code: "lblHomePage",
        size: "lg"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $a3vgd.ChargingStatistics), {
        stats: userStatistics,
        direction: isDesktopScreen ? "row" : "column"
    })), allReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $7Q01G.default), {
        text: text("lblOwnerReadOnlyActivatedMultiple"),
        alertType: (0, $7Q01G.AlertType).Info,
        "data-testid": "ownerReadOnlyActivated-msg"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row margin-bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, haloChargePoints.map((c)=>{
        if (c.ocppServerMode === "Internal") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).Fragment, {
            key: `${c.id}-halo-internal`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $93hlo.ChargePointStatusWidget), {
            chargePoint: c,
            nameInTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $eW4Jt.ChargePointOcppHaloControlWidget), {
            chargePoint: c,
            isReadOnly: c.ownerReadOnly === true
        }));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $9BVHD.ChargePointCapiHaloControlWidget), {
            key: `${c.id}-halo-capi`,
            chargePoint: c,
            isReadOnly: c.ownerReadOnly === true
        });
    }), auraChargePoints.map((c)=>{
        if (c.ocppServerMode === "Internal") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).Fragment, {
            key: `${c.id}-aura-internal`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $93hlo.ChargePointStatusWidget), {
            chargePoint: c,
            nameInTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2EXu7.ChargePointOcppAuraControlWidget), {
            chargePoint: c,
            userId: user?.id,
            isReadOnly: c.ownerReadOnly === true
        }));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5LXeP.ChargePointCapiAuraControlWidget), {
            key: `${c.id}-aura-capi`,
            chargePoint: c,
            userId: user?.id,
            isReadOnly: c.ownerReadOnly === true
        });
    }), dawnChargePoints.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).Fragment, {
            key: `${c.id}-dawn`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $93hlo.ChargePointStatusWidget), {
            chargePoint: c,
            nameInTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $l0Y5b.ChargePointDawnControlWidget), {
            chargePoint: c,
            isReadOnly: c.ownerReadOnly === true
        }))), lunaChargePoints.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).Fragment, {
            key: `${c.id}-luna`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $93hlo.ChargePointStatusWidget), {
            chargePoint: c,
            nameInTitle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $3O3iR.ChargePointLunaControlWidget), {
            chargePoint: c,
            isReadOnly: c.ownerReadOnly === true
        }))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8Z9am.WidgetLoadingState), {
        height: "285px"
    })), chargingSessions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-7",
        "data-testid": "Chargingsessionsection"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $96e348eb88b13195$export$d96ee243323785bc), {
        sessions: chargingSessions,
        showEndTime: false
    })), chargingSessionLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-7",
        "data-testid": "Chargingsessionsection-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8Z9am.WidgetLoadingState), {
        height: "450px"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $103c66ce6c3e5a3f$export$75ed7dfd858fd56a), {
        visible: showGreenChargingDialog,
        onAccept: setInformed,
        close: ()=>setShowGreenChargingDialog(false)
    }));
}





var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $gCMx8 = parcelRequire("gCMx8");

var $e19ko = parcelRequire("e19ko");

var $e35UK = parcelRequire("e35UK");

var $fzqPg = parcelRequire("fzqPg");

var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $g1rJs = parcelRequire("g1rJs");

var $fzqPg = parcelRequire("fzqPg");

var $912qS = parcelRequire("912qS");

var $1IbJL = parcelRequire("1IbJL");
const $2c3d9fda95bcec9b$var$SButtonGroup = (0, $avNx5.default).div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px;
    letter-spacing: 1%;
    gap: 8px;
    font-size: 16px;
`;
const $2c3d9fda95bcec9b$var$SText = (0, $avNx5.default).div`
    font-size: 20px;
    line-height: 38px;
    text-align: center;
    letter-spacing: 1%;
    a {
        color: #006ef0;
    }
    a:hover {
        cursor: pointer;
        color: #8abfff;
    }
`;
function $2c3d9fda95bcec9b$export$1ef146911fa9c3b({ cancel: cancel, accept: accept, errorMessage: errorMessage }) {
    const text = (0, $1IbJL.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2 solid"
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $912qS.SAlert), {
        type: "error",
        className: "margin-top-small",
        "data-testid": "alert-error"
    }, errorMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($2c3d9fda95bcec9b$var$SText, {
        className: "row margin-top-med margin-bottom-med",
        "data-testid": "info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgUserAgreementInfo",
        values: {
            link: {
                href: `https://www.chargeamps.com/${text("linkTermsOfService")}`,
                target: "_new"
            },
            link2: {
                href: `https://www.chargeamps.com/${text("linkPrivacyPolicy")}`,
                target: "_new"
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($2c3d9fda95bcec9b$var$SButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        label: text("btnAccept"),
        onClick: ()=>accept(),
        "data-testid": "accept-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        label: text("btnCancel"),
        text: true,
        onClick: ()=>cancel(),
        "data-testid": "cancel-btn"
    }))));
}





var $2GMY2 = parcelRequire("2GMY2");

var $1IbJL = parcelRequire("1IbJL");

var $7dhC8 = parcelRequire("7dhC8");

var $5wiCS = parcelRequire("5wiCS");
const $3696a0d4ee907942$var$SColumn = (0, $avNx5.default).div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const $3696a0d4ee907942$var$STitle = (0, $avNx5.default).div`
    color: #000000;
    letter-spacing: 1%;
    font-size: 30px;
`;
const $3696a0d4ee907942$var$SChargeAmpsLandingPageLogo = (0, $avNx5.default)((0, $e35UK.ChargeAmpsLandingPageLogo))`
    fill: ${({ theme: theme, dark: dark })=>dark ? theme.font.lightestColor : theme.font.darkestColor};
`;
function $3696a0d4ee907942$export$5573dc5ce5740818() {
    const text = (0, $1IbJL.default)();
    const navigate = (0, $gCMx8.useNavigate)();
    const dispatch = (0, $e19ko.useDispatch)();
    const user = (0, $5wiCS.useSessionUser)();
    const [errorMessage, setErrorMessage] = (0, $jGnJo.useState)(null);
    const [acceptTerms] = (0, $2GMY2.useUserAcceptTermsMutation)();
    const cancel = ()=>{
        navigate("/login", {
            replace: true
        });
    };
    const handleAcceptTerms = ()=>{
        acceptTerms().unwrap().then(()=>{
            const updatedUser = {
                ...user,
                personalAccept: new Date().toDateString()
            };
            dispatch((0, $7dhC8.setUser)(updatedUser));
            navigate("/dashboard", {
                replace: true
            });
        }).catch(()=>setErrorMessage(text("msgErrorAcceptingTerms")));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "logo",
        "data-testid": "logo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($3696a0d4ee907942$var$SChargeAmpsLandingPageLogo, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "page-layout-container",
        "data-testid": "container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($3696a0d4ee907942$var$SColumn, {
        className: "row text-center heading",
        "data-testid": "tite-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($3696a0d4ee907942$var$STitle, {
        className: "row",
        "data-testid": "title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblTermsOfServicePage"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2c3d9fda95bcec9b$export$1ef146911fa9c3b), {
        cancel: cancel,
        accept: handleAcceptTerms,
        errorMessage: errorMessage
    }))));
}





var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $gCMx8 = parcelRequire("gCMx8");

var $gCykg = parcelRequire("gCykg");

var $3aX9D = parcelRequire("3aX9D");

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $3wCei = parcelRequire("3wCei");

var $gCMx8 = parcelRequire("gCMx8");

var $angn7 = parcelRequire("angn7");

var $aPE86 = parcelRequire("aPE86");

var $2GMY2 = parcelRequire("2GMY2");

var $a3EFh = parcelRequire("a3EFh");

var $gIveR = parcelRequire("gIveR");

var $2RQ8A = parcelRequire("2RQ8A");

var $eQidV = parcelRequire("eQidV");

var $fzqPg = parcelRequire("fzqPg");

var $3owfH = parcelRequire("3owfH");

var $jGnJo = parcelRequire("jGnJo");
var $9d99fb34b5fec603$export$2e2bcd8739ae039 = (effect, deps)=>{
    const isInitialMount = (0, $jGnJo.useRef)(true);
    (0, $jGnJo.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else return effect();
    }, deps);
};



var $gCykg = parcelRequire("gCykg");

var $ecLB8 = parcelRequire("ecLB8");

var $1IbJL = parcelRequire("1IbJL");
const $e5fa507abe581a1a$var$ContentWrapper = (0, $avNx5.default).div`
    width: 750px;
    font-size: 16px;
    padding: 0 10px;
`;
const $e5fa507abe581a1a$var$Row = (0, $avNx5.default).div`
    display: flex;
    width: ${({ short: short })=>short ? "50%" : "100%"};
    gap: 40px;
    justify-content: space-between;

    @media screen and (max-width: 775px) {
        flex-direction: column;
        width: 100%;
        margin-bottom: 40px;
    }

    @media screen and (min-width: 776px) {
        & > *:first-child:nth-last-child(1) {
            padding-right: 20px;
        }
    }
`;
const $e5fa507abe581a1a$var$Spacer = (0, $avNx5.default).div`
    margin-bottom: 30px;
`;
const $e5fa507abe581a1a$var$AgreementContainer = (0, $avNx5.default).div`
    width: 70%;
    text-align: center;
    align-self: center;

    @media screen and (max-width: 775px) {
        width: 100%;
    }

    a {
        color: ${({ theme: theme })=>theme.brandColors.CA_Blue};
    }
`;
const $e5fa507abe581a1a$var$Form = (0, $avNx5.default).form`
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 776px) {
        gap: 40px;
    }
`;
const $e5fa507abe581a1a$var$ReturnButton = (0, $avNx5.default).div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme: theme })=>theme.font.midDarkColor};

    &:hover {
        cursor: pointer;
    }
`;
const $e5fa507abe581a1a$var$initialFormData = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: ""
};
function $e5fa507abe581a1a$export$3bd2b4ee8d70ffe2({ className: className, style: style, setStatus: setStatus }) {
    const text = (0, $1IbJL.default)();
    const navigate = (0, $gCMx8.useNavigate)();
    const [createUser, { isLoading: loading }] = (0, $2GMY2.useAuthRegisterMutation)();
    const [formData, setFormData] = (0, $jGnJo.useState)($e5fa507abe581a1a$var$initialFormData);
    const [formErrors, setFormErrors] = (0, $jGnJo.useState)($e5fa507abe581a1a$var$initialFormData);
    const [signUpError, setSignUpError] = (0, $jGnJo.useState)(undefined);
    const [showPassword, toggleShowPassword] = (0, $jGnJo.useState)(false);
    const createUserSchema = ()=>$3wCei.object().shape({
            firstName: $3wCei.string().required(text("lblEnterFirstName")).max((0, $angn7.MAX_FIRST_NAME_LENGTH), text("lblMaxOfCharacters", {
                maxLength: (0, $angn7.MAX_FIRST_NAME_LENGTH)
            })),
            lastName: $3wCei.string().required(text("lblEnterLastName")).max((0, $angn7.MAX_LAST_NAME_LENGTH), text("lblMaxOfCharacters", {
                maxLength: (0, $angn7.MAX_LAST_NAME_LENGTH)
            })),
            mobile: $3wCei.string().required(text("lblEnterMobile")).max((0, $angn7.MAX_MOBILE_LENGTH), text("lblMaxOfCharacters", {
                maxLength: (0, $angn7.MAX_MOBILE_LENGTH)
            })),
            email: $3wCei.string().email(text("lblInvalidEmail")).required(text("lblEnterEmail")).test("match", text("lblInvalidEmail"), (val)=>(0, $ecLB8.validateEmailFormat)(val ?? "")),
            password: $3wCei.string().min((0, $angn7.MIN_PASSWORD_LENGTH), text("msgPasswordToShortSignup")).required(text("msgPasswordToShortSignup"))
        });
    /** Remove error message when start typing */ (0, $9d99fb34b5fec603$export$2e2bcd8739ae039)(()=>{
        if (signUpError) setSignUpError(undefined);
    }, [
        formData
    ]);
    /*******************************************/ const handleSubmit = async (event)=>{
        event.preventDefault();
        try {
            await createUserSchema().validate(formData, {
                abortEarly: false
            });
            setFormErrors(()=>$e5fa507abe581a1a$var$initialFormData);
            await createUser({
                chargePointUser: {
                    ...formData,
                    personalAccept: new Date().toISOString()
                }
            }).unwrap();
            setStatus("success");
        } catch (error) {
            if (error instanceof $3wCei.ValidationError) {
                setFormErrors((0, $aPE86.formatValidationErrorData)(error, $e5fa507abe581a1a$var$initialFormData) || $e5fa507abe581a1a$var$initialFormData);
                return;
            }
            const errorMessageCode = (0, $a3EFh.getErrorMessageCode)(error);
            if (errorMessageCode) setSignUpError(text(errorMessageCode));
            else setStatus("failed");
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$ContentWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$Spacer, null, signUpError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SNotification), {
        "data-testid": "notificationError",
        error: true
    }, signUpError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$Spacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $eQidV.FormHeader), {
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$Form, {
        onSubmit: handleSubmit,
        noValidate: true,
        autoComplete: "off"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.InputGroup), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.firstName.length > 0 ? text("lblFirstName") : "",
        errorTestId: "signUpFirstNameErrorMsg",
        errorMsg: formErrors.firstName,
        inverted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.SInput), {
        "data-testid": "firstNameInput",
        type: "text",
        placeholder: text("lblFirstName"),
        onChange: (e)=>setFormData({
                ...formData,
                firstName: e.target.value
            }),
        autoFocus: true,
        formNoValidate: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.InputGroup), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.lastName.length > 0 ? text("lblLastNameShortField") : "",
        errorTestId: "signUpLastNameErrorMsg",
        errorMsg: formErrors.lastName,
        inverted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.SInput), {
        "data-testid": "lastNameInput",
        type: "text",
        placeholder: text("lblLastNameShortField"),
        onChange: (e)=>setFormData({
                ...formData,
                lastName: e.target.value
            }),
        formNoValidate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.InputGroup), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.email.length > 0 ? text("lblEmail") : "",
        errorTestId: "signUpEmailErrorMsg",
        errorMsg: formErrors.email,
        inverted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.SInput), {
        "data-testid": "emailInput",
        name: "email",
        type: "email",
        placeholder: text("lblEmail"),
        onChange: (e)=>setFormData({
                ...formData,
                email: e.target.value
            }),
        formNoValidate: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.InputGroup), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.mobile.length > 0 ? text("lblContactNumberShortField") : "",
        errorTestId: "signUpMobileErrorMsg",
        errorMsg: formErrors.mobile,
        inverted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.SInput), {
        "data-testid": "mobileInput",
        type: "text",
        placeholder: text("lblContactNumberShortField"),
        onChange: (e)=>setFormData({
                ...formData,
                mobile: e.target.value
            }),
        formNoValidate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$Row, {
        short: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $3owfH.PasswordInput), {
        style: {
            width: "100%",
            height: "40px"
        },
        label: formData.password.length > 0 ? text("lblPassword") : "",
        errorTestId: "signUpPasswordErrorMsg",
        error: formErrors.password,
        placeholder: text("lblPassword"),
        showPassword: showPassword,
        toggleShowPasswordFlag: toggleShowPassword,
        onChange: (value)=>setFormData({
                ...formData,
                password: value
            }),
        hasText: formData.password.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$AgreementContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgUserAgreementSignUpInfo",
        values: {
            link: {
                href: `https://www.chargeamps.com/${text("linkLegal")}`,
                target: "_new"
            },
            link2: {
                href: `https://www.chargeamps.com/${text("linkPrivacyPolicy")}`,
                target: "_new"
            }
        },
        "data-testid": "agreementText"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2RQ8A.SubmitButton), {
        disabled: loading,
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "btnSignUp"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($e5fa507abe581a1a$var$ReturnButton, {
        onClick: ()=>navigate("/login"),
        "data-testid": "goToSignIn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblReturnToSignIn"
    }))));
}





var $b2a4Y = parcelRequire("b2a4Y");

var $fzqPg = parcelRequire("fzqPg");

var $1IbJL = parcelRequire("1IbJL");
const $6fbde30acf054b99$var$Title = (0, $avNx5.default).div`
    font-size: 24px;
    margin-bottom: 20px;
`;
function $6fbde30acf054b99$export$265471dcab9022d3({ className: className, style: style }) {
    const navigate = (0, $gCMx8.useNavigate)();
    const text = (0, $1IbJL.default)();
    const [status, setStatus] = (0, $jGnJo.useState)("signup");
    (0, $jGnJo.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        background: (0, $3aX9D.theme).whiteBackground,
        hideLanguageSelect: true
    }, status === "signup" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $e5fa507abe581a1a$export$3bd2b4ee8d70ffe2), {
        setStatus: setStatus
    }), status === "failed" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $b2a4Y.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>navigate("/login", {
                replace: true
            }),
        type: (0, $b2a4Y.LandingMessageType).ERROR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6fbde30acf054b99$var$Title, {
        "data-testid": "errorTitle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblSomethingWentWrong"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        "data-testid": "erroMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblSignUpError"
    }))), status === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $b2a4Y.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>navigate("/login", {
                replace: true
            }),
        type: (0, $b2a4Y.LandingMessageType).SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6fbde30acf054b99$var$Title, {
        "data-testid": "successTitle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblSignUpSuccessTitle"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        "data-testid": "successMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblSignUpSuccess"
    }))));
}





var $jGnJo = parcelRequire("jGnJo");

var $jzUeY = parcelRequire("jzUeY");

var $avNx5 = parcelRequire("avNx5");

var $e19ko = parcelRequire("e19ko");

var $gCMx8 = parcelRequire("gCMx8");

var $g1rJs = parcelRequire("g1rJs");

var $fzqPg = parcelRequire("fzqPg");

var $gCykg = parcelRequire("gCykg");

var $eQidV = parcelRequire("eQidV");

var $9kHDr = parcelRequire("9kHDr");

var $fv8x4 = parcelRequire("fv8x4");

var $jS4TD = parcelRequire("jS4TD");

var $2GMY2 = parcelRequire("2GMY2");

var $3aX9D = parcelRequire("3aX9D");

var $jFlTe = parcelRequire("jFlTe");

var $1IbJL = parcelRequire("1IbJL");

var $ercFZ = parcelRequire("ercFZ");

var $k6XqL = parcelRequire("k6XqL");
const $6c5d853802269792$var$ButtonGroup = (0, $avNx5.default).div`
    padding-top: 15px;
    display: flex;
    justify-content: center;
    gap: 10px;
`;
const $6c5d853802269792$var$SSpacer = (0, $avNx5.default).div`
    margin-bottom: 49px;
`;
const $6c5d853802269792$var$SContentWrapper = (0, $avNx5.default)((0, $gCykg.SContentWrapper))`
    max-width: 510px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const $6c5d853802269792$var$SRegisterChargerInfo = (0, $avNx5.default).div`
    font-weight: var(--font-weight-light);
    font-size: 14px;
    color: ${({ theme: theme })=>theme.font.midDarkColor};
    &,
    & > p {
        line-height: 22px;
    }
`;
const $6c5d853802269792$var$SWarningMessage = (0, $avNx5.default).div`
    display: flex;
    justify-content: space-around;
    font-size: 11px;
    border: 1px solid #a1a1a1;
    border-radius: 6px;
    padding: 15px 11px;
    margin-bottom: 10px;
`;
const $6c5d853802269792$var$SWarningMessageIcon = (0, $avNx5.default).span`
    margin-top: 2px;
    padding-right: 5px;
`;
function $6c5d853802269792$export$4a4cbf17073b70ff() {
    const text = (0, $1IbJL.default)();
    const navigate = (0, $gCMx8.useNavigate)();
    const signOut = (0, $jFlTe.useSignOut)();
    const userId = (0, $e19ko.useSelector)((state)=>state.user.id);
    const { register: register, handleSubmit: handleSubmit, control: control, formState: { errors: errors, isSubmitted: isSubmitted, isValid: isValid } } = (0, $jzUeY.useForm)({
        mode: "onSubmit",
        reValidateMode: "onChange",
        defaultValues: {
            chargePointId: "",
            name: "",
            wifiPassword: ""
        }
    });
    const nameLength = (0, $jzUeY.useWatch)({
        control: control,
        name: "name",
        defaultValue: ""
    }).trim().length;
    const [addChargerToUser] = (0, $2GMY2.useChargePointSetOwnerMutation)();
    const doAddChargertoUser = async (data)=>{
        const name = data.name.trim();
        try {
            await addChargerToUser({
                userId: userId,
                chargePointId: data.chargePointId,
                name: name || data.chargePointId,
                wifiPassword: data.wifiPassword
            }).unwrap();
            navigate("/dashboard", {
                replace: true
            });
        } catch (error) {
            if ((0, $jS4TD.isFetchBaseQueryError)(error) && (error.status === 409 || error.status === 404 || error.status === 403) && typeof error.data === "object" && error.data !== null && "error" in error.data && typeof error.data.error === "string") (0, $fv8x4.notifyError)(error.data.error);
            else (0, $fv8x4.notifyError)("msgChargerNotAddedtoUser");
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.LandingPageLayout), {
        background: (0, $3aX9D.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6c5d853802269792$var$SContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6c5d853802269792$var$SSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $eQidV.SFormHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblRegisterChargepointPage"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("form", {
        "data-testid": "create-modal-form",
        onSubmit: handleSubmit(doAddChargertoUser),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6c5d853802269792$var$SSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        label: text("lblSerialNumber"),
        ...register("chargePointId", {
            required: {
                value: true,
                message: text("msgSerialNumberRequired")
            }
        }),
        id: "serialNumber",
        error: errors.chargePointId?.message,
        "data-testid": "serialNumber",
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "margin-top-med "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        label: text("lblPin"),
        id: "charger-pin",
        ...register("wifiPassword", {
            required: {
                value: true,
                message: text("msgPinCodeRequired")
            },
            maxLength: {
                value: 8,
                message: text("msgPinCodeLength")
            }
        }),
        error: errors?.wifiPassword?.message,
        "data-testid": "pinCode",
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "margin-top-med "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        id: "name",
        label: text("lblChargersNameField"),
        ...register("name", {
            validate: (value)=>value.trim().length <= (0, $ercFZ.MAX_NAME_LENGTH) || text("lblNameError")
        }),
        error: errors.name?.message,
        subtitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
            className: "flex justify-content-end"
        }, text("msgTextAreaCounter", {
            textCount: nameLength,
            maxLength: (0, $ercFZ.MAX_NAME_LENGTH)
        })),
        "data-testid": "name"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6c5d853802269792$var$SSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6c5d853802269792$var$SWarningMessage, {
        "data-testid": "warningtext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6c5d853802269792$var$SWarningMessageIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $9kHDr.AlertIcon), {
        size: 20,
        fill: (0, $3aX9D.theme).brandColors.CA_Blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblRegisterChargepointPageWarning"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6c5d853802269792$var$SRegisterChargerInfo, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgRegisterChargerInfo"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($6c5d853802269792$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        label: text("btnCancel"),
        outlined: true,
        onClick: signOut,
        "data-testid": "cancelBtn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        label: text("btnNext"),
        icon: "pi pi-arrow-right",
        iconPos: "right",
        type: "submit",
        "data-testid": "goBtn",
        disabled: isSubmitted && !isValid
    }))))));
}





var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $2GMY2 = parcelRequire("2GMY2");

var $dtjOS = parcelRequire("dtjOS");

var $5LXeP = parcelRequire("5LXeP");

var $9BVHD = parcelRequire("9BVHD");

var $insTi = parcelRequire("insTi");

var $l0Y5b = parcelRequire("l0Y5b");

var $2EXu7 = parcelRequire("2EXu7");

var $eW4Jt = parcelRequire("eW4Jt");

var $j7d1a = parcelRequire("j7d1a");

var $2p1p9 = parcelRequire("2p1p9");

var $g7ZMG = parcelRequire("g7ZMG");

var $bmUtn = parcelRequire("bmUtn");

var $61HZy = parcelRequire("61HZy");
parcelRequire("5gIXE");
var $8Z9am = parcelRequire("8Z9am");

var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $gCMx8 = parcelRequire("gCMx8");

var $g1rJs = parcelRequire("g1rJs");

var $dtjOS = parcelRequire("dtjOS");

var $a58Ve = parcelRequire("a58Ve");

var $2f0xp = parcelRequire("2f0xp");

var $7pG2V = parcelRequire("7pG2V");

var $dRNw9 = parcelRequire("dRNw9");

var $bLjZo = parcelRequire("bLjZo");

var $2GMY2 = parcelRequire("2GMY2");

var $1IbJL = parcelRequire("1IbJL");

var $5wiCS = parcelRequire("5wiCS");
const $029d35ff05317ad4$var$SDisabledOverlay = (0, $avNx5.default).div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(212, 212, 212, 0.5);
    z-index: 1;
`;
const $029d35ff05317ad4$var$OpenSmartScheduleButton = ({ chargePoint: chargePoint, existing: existing, isGreenChargingEnabled: isGreenChargingEnabled, loading: loading, enabled: enabled })=>{
    const text = (0, $1IbJL.default)();
    const hasSmartScheduleSupport = (0, $jGnJo.useMemo)(()=>(0, $dtjOS.doesSupportSmartSchedule)(chargePoint), [
        chargePoint
    ]);
    const link = `${(0, $7pG2V.isUserappDomain) ? "/remotecontrol" : "/chargepoints"}/${chargePoint.id}/schedule`;
    const disabled = isGreenChargingEnabled || !hasSmartScheduleSupport;
    const buttonLabel = ()=>{
        if (!existing) return text("lblCreateScheduleLink");
        return text(enabled ? "btnEditSchedule" : "btnViewSchedule");
    };
    const buttonProps = {
        label: buttonLabel(),
        icon: "pi pi-calendar",
        "data-testid": "link-to-smart"
    };
    return disabled || loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        ...buttonProps,
        loading: loading,
        disabled: disabled
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCMx8.Link), {
        "aria-label": buttonProps.label,
        className: "p-button p-component",
        "data-testid": buttonProps["data-testid"],
        to: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
        "aria-hidden": "true",
        className: "p-button-icon p-c p-button-icon-left pi pi-calendar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
        className: "p-button-label p-c"
    }, buttonProps.label));
};
const $029d35ff05317ad4$export$3eb892732573ae85 = ({ chargePoint: chargePoint, isGreenChargingEnabled: isGreenChargingEnabled, loading: loading })=>{
    const text = (0, $1IbJL.default)();
    const user = (0, $5wiCS.useSessionUser)();
    const userHasEditRights = (0, $jGnJo.useMemo)(()=>(0, $2f0xp.default)(chargePoint, user), [
        chargePoint,
        user
    ]);
    const { data: schedules } = (0, $2GMY2.useSmartChargingScheduleGetByChargePointQuery)({
        chargePointId: chargePoint.id || ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).Fragment, null, userHasEditRights && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bLjZo.WidgetLayout), {
        title: text("lblSchedulingWidget"),
        "data-testid": "smart-scheduling-widget",
        loadingStatus: loading,
        actionButtons: userHasEditRights && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $a58Ve.SButtonsGroupContainer), {
            className: "action-btns"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($029d35ff05317ad4$var$OpenSmartScheduleButton, {
            chargePoint: chargePoint,
            existing: !!schedules?.length,
            isGreenChargingEnabled: isGreenChargingEnabled,
            loading: loading,
            enabled: userHasEditRights
        }))
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "shimmer-container shimmer-medium"
    }) : isGreenChargingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $dRNw9.GreenChargingBadge), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($029d35ff05317ad4$var$SDisabledOverlay, null)) : null));
};





var $cEkC2 = parcelRequire("cEkC2");

var $3O3iR = parcelRequire("3O3iR");

var $93hlo = parcelRequire("93hlo");

var $9Rt6A = parcelRequire("9Rt6A");

var $fv8x4 = parcelRequire("fv8x4");

var $1IbJL = parcelRequire("1IbJL");

var $5wiCS = parcelRequire("5wiCS");

var $jGnJo = parcelRequire("jGnJo");

var $jzUeY = parcelRequire("jzUeY");

var $g1rJs = parcelRequire("g1rJs");

var $4vgEB = parcelRequire("4vgEB");

var $1IbJL = parcelRequire("1IbJL");

var $jS4TD = parcelRequire("jS4TD");

var $2GMY2 = parcelRequire("2GMY2");

var $7XnEw = parcelRequire("7XnEw");

var $k6XqL = parcelRequire("k6XqL");

var $5J0i6 = parcelRequire("5J0i6");

var $4wzzF = parcelRequire("4wzzF");
const $7df6883444221703$var$getGrantErrorMessageKey = (error)=>{
    if (!(0, $jS4TD.isFetchBaseQueryError)(error)) return "msgServicePartnerAccessGrantFailed";
    switch(error.status){
        case 403:
            return "msgServicePartnerAccessUnavailable";
        case 404:
            return "msgServicePartnerAccessInvalidCode";
        case 400:
            return "msgServicePartnerAccessRequestInvalid";
        case 409:
            return "msgServicePartnerAccessRequestRejected";
        case 410:
            return "msgServicePartnerAccessCodeExpired";
        default:
            return "msgServicePartnerAccessGrantFailed";
    }
};
function $7df6883444221703$export$1f3cb238d87f8dde({ chargePointId: chargePointId, isAccessAvailable: isAccessAvailable }) {
    const text = (0, $1IbJL.default)();
    const toast = (0, $4wzzF.useToast)();
    const [isAuthorised, setIsAuthorised] = (0, $jGnJo.useState)(false);
    const [grantServicePartnerAccess, { isLoading: isGranting }] = (0, $2GMY2.useChargePointAddServicePartnerMutation)();
    const { handleSubmit: handleSubmit, register: register, reset: reset, setValue: setValue, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting, isValid: isValid } } = (0, $jzUeY.useForm)({
        defaultValues: {
            partnerReferenceCode: ""
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    const partnerReferenceCodeRegistration = register("partnerReferenceCode", {
        required: text("msgServicePartnerCodeRequired"),
        validate: (value)=>value.trim().length === 8 || text("msgServicePartnerCodeInvalid")
    });
    const grantAccess = async ({ partnerReferenceCode: partnerReferenceCode })=>{
        if (!isAuthorised) return;
        try {
            await grantServicePartnerAccess({
                chargePointId: chargePointId,
                addServicePartnerByCodeRequest: {
                    code: partnerReferenceCode.trim()
                }
            }).unwrap();
            toast.notifySuccess(text("msgServicePartnerAccessGranted"));
            reset();
            setIsAuthorised(false);
        } catch (error) {
            toast.notifyError(text($7df6883444221703$var$getGrantErrorMessageKey(error)));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5J0i6.Panel), {
        title: text("lblServicePartnerAccessWidgetTitle"),
        headerIcon: "pi pi-shield",
        headerActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $7XnEw.FieldInfoButton), {
            ariaLabel: text("lblMoreInformation"),
            text: text("msgServicePartnerAccessInformation"),
            testId: "service-partner-access-info-button"
        }),
        className: "mt-4",
        testId: "service-partner-access-widget"
    }, !isAccessAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("p", {
        className: "m-0"
    }, text("msgServicePartnerAccessUnavailable")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("p", {
        className: "mt-0 text-color-secondary"
    }, text("msgServicePartnerAccessWidgetDescription")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("form", {
        onSubmit: handleSubmit(grantAccess),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("label", {
        className: "p-label required-label",
        htmlFor: "service-partner-access-reference-code"
    }, text("lblServicePartnerReferenceCode")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        id: "service-partner-access-reference-code",
        "data-testid": "service-partner-access-reference-code",
        ...partnerReferenceCodeRegistration,
        onChange: (event)=>{
            setValue("partnerReferenceCode", event.target.value.toUpperCase(), {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: isSubmitted
            });
            setIsAuthorised(false);
        },
        error: errors.partnerReferenceCode?.message,
        disabled: isGranting || isSubmitting,
        placeholder: "ABCDEFGH",
        maxLength: 8,
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex align-items-center gap-2 mt-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $4vgEB.Checkbox), {
        inputId: "service-partner-access-authorisation",
        checked: isAuthorised,
        onChange: (event)=>setIsAuthorised(!!event.checked),
        disabled: isGranting || isSubmitting
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("label", {
        htmlFor: "service-partner-access-authorisation",
        className: "line-height-3"
    }, text("msgConfirmServicePartnerAccessAuthorised"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "submit",
        label: text("btnGrantServicePartnerAccess"),
        className: "mt-3",
        disabled: !isAuthorised || isGranting || isSubmitting || isSubmitted && !isValid,
        loading: isGranting
    }))));
}




const $b04f289a0c2e8dcb$var$Container = (0, $avNx5.default).div`
    margin-top: 40px;
`;
const $b04f289a0c2e8dcb$var$ChargePointContainer = (0, $avNx5.default).div`
    margin-top: 40px;
    display: flex;

    @media screen and (max-width: 990px) {
        flex-direction: column;
    }
`;
const $b04f289a0c2e8dcb$var$TabList = (0, $avNx5.default).div`
    display: flex;
    padding: 0 15px;
`;
const $b04f289a0c2e8dcb$var$ShimmerTab = (0, $avNx5.default).div`
    width: 100px;
    height: 20px;
    border-radius: 4px;
`;
const $b04f289a0c2e8dcb$var$Tab = (0, $avNx5.default).div`
    border: 1px solid ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
    border-radius: 6px 6px 0 0;
    border-bottom: none;
    padding: 10px 20px;
    background-color: ${({ theme: theme, selected: selected })=>selected ? theme.font.lightestColor : theme.brandColors.CA_Light_Gray};

    font-weight: var(--font-weight-light);
    &:hover {
        cursor: pointer;
    }
`;
const $b04f289a0c2e8dcb$export$31f6100da20592ef = /*#__PURE__*/ (0, $jGnJo.memo)(function UserAppRemoteControlPage() {
    const text = (0, $1IbJL.default)();
    const user = (0, $5wiCS.useSessionUser)();
    const [selectedChargePointId, setSelectedChargePointId] = (0, $jGnJo.useState)();
    const [getGCData, { data: chargePointStatus }] = (0, $2GMY2.useLazyGreenChargingChargePointStatusQuery)();
    const { data: chargePoints, isSuccess: isSuccess, isLoading: isLoading } = (0, $2GMY2.useUserGetOwnedChargePointsQuery)({
        expand: `${(0, $j7d1a.default).OcppConfig},${(0, $j7d1a.default).TopChargingLimitation}`
    }, {
        pollingInterval: (0, $9Rt6A.CHARGE_POINT_REFRESH_TIMEOUT)
    });
    const selectedChargePoint = chargePoints?.find((chargePoint)=>chargePoint.id === selectedChargePointId) ?? chargePoints?.[0];
    const canGrantServicePartnerAccess = !!(selectedChargePoint?.companyId && user.roles.some((role)=>role.companyId === selectedChargePoint.companyId));
    const getGreenChargingData = async (chargePointId)=>{
        await getGCData({
            chargePointId: chargePointId
        }).unwrap().catch(()=>(0, $fv8x4.notifyError)(text("msgFailedToGetGCData")));
    };
    const onTabClick = async (chargePoint)=>{
        setSelectedChargePointId(chargePoint.id);
        await getGreenChargingData(chargePoint.id);
    };
    /*************************************/ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
        code: "lblRemoteControlPage",
        size: "lg",
        "data-testid": "header",
        loading: isLoading
    }), isSuccess && chargePoints ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$TabList, null, chargePoints?.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$Tab, {
            selected: selectedChargePoint?.id === c.id,
            onClick: ()=>onTabClick(c),
            key: c.id,
            "data-testid": c.id
        }, c.name))), selectedChargePoint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$ChargePointContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, (0, $61HZy.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode !== "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $9BVHD.ChargePointCapiHaloControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    }), (0, $61HZy.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode === "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $eW4Jt.ChargePointOcppHaloControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    }), (0, $g7ZMG.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode !== "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5LXeP.ChargePointCapiAuraControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly,
        userId: user?.id
    }), (0, $g7ZMG.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode === "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2EXu7.ChargePointOcppAuraControlWidget), {
        userId: user?.id,
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    }), (0, $bmUtn.default)(selectedChargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $l0Y5b.ChargePointDawnControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    }), (0, $cEkC2.default)(selectedChargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $3O3iR.ChargePointLunaControlWidget), {
        chargePoint: selectedChargePoint,
        isReadOnly: selectedChargePoint.ownerReadOnly
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $93hlo.ChargePointStatusWidget), {
        chargePoint: selectedChargePoint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $7df6883444221703$export$1f3cb238d87f8dde), {
        key: selectedChargePoint.id,
        chargePointId: selectedChargePoint.id,
        isAccessAvailable: canGrantServicePartnerAccess
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, !(0, $bmUtn.default)(selectedChargePoint) && selectedChargePoint.ocppServerMode !== "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $insTi.ChargePointCapiScheduledChargingWidget), {
        chargePoint: selectedChargePoint,
        isGreenChargingEnabled: chargePointStatus?.greenChargingStatus?.greenChargingOn
    }), (0, $dtjOS.canShowSmartScheduling)(selectedChargePoint, user?.isSuperAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $029d35ff05317ad4$export$3eb892732573ae85), {
        chargePoint: selectedChargePoint,
        isGreenChargingEnabled: chargePointStatus?.greenChargingStatus?.greenChargingOn
    })))) : null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$TabList, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$Tab, {
        selected: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$ShimmerTab, {
        className: "shimmer-container"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($b04f289a0c2e8dcb$var$ChargePointContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8Z9am.WidgetLoadingState), {
        height: "285px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8Z9am.WidgetLoadingState), {
        height: "285px"
    })))));
});





var $jGnJo = parcelRequire("jGnJo");

var $e19ko = parcelRequire("e19ko");

var $2p1p9 = parcelRequire("2p1p9");

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $e19ko = parcelRequire("e19ko");

var $g1rJs = parcelRequire("g1rJs");

var $angn7 = parcelRequire("angn7");

var $2p1p9 = parcelRequire("2p1p9");

var $2fIUB = parcelRequire("2fIUB");

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $g1rJs = parcelRequire("g1rJs");

var $1IbJL = parcelRequire("1IbJL");

var $k6XqL = parcelRequire("k6XqL");
const $13384ffac91a0049$var$emptyPasswordChange = ()=>({
        currentPassword: "",
        newPassword: "",
        passwordCompare: ""
    });
function $13384ffac91a0049$export$fb7f3eeb32bd6cd0({ className: className, style: style, onChange: onChange, openPasswordChange: openPasswordChange, setOpenPasswordChange: setOpenPasswordChange }) {
    const text = (0, $1IbJL.default)();
    const [passwordChange, setPasswordChange] = (0, $jGnJo.useState)($13384ffac91a0049$var$emptyPasswordChange);
    const openForm = ()=>{
        setPasswordChange($13384ffac91a0049$var$emptyPasswordChange());
        setOpenPasswordChange(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))("flex flex-column", className),
        style: style
    }, !openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        label: text("lblChangePasswordLink"),
        icon: "pi pi-lock",
        text: true,
        severity: "info",
        className: "align-self-start px-0",
        onClick: openForm,
        "data-testid": "openPasswordChange"
    }), openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex flex-column gap-3",
        "data-testid": "passwordChange"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("h3", {
        className: "m-0 text-lg font-semibold"
    }, text("lblChangingPassword")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        id: "currentPassword",
        label: text("lblCurrentPasswordField"),
        type: "password",
        onChange: (e)=>setPasswordChange((prev)=>({
                    ...prev,
                    currentPassword: e.target.value
                })),
        onBlur: ()=>onChange({
                passwordChange: passwordChange
            }),
        "data-testid": "currentPassword",
        className: "w-full md:w-20rem"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex flex-column md:flex-row gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        id: "newPassword",
        label: text("lblNewPasswordField"),
        type: "password",
        onChange: (e)=>setPasswordChange((prev)=>({
                    ...prev,
                    newPassword: e.target.value
                })),
        onBlur: ()=>onChange({
                passwordChange: passwordChange
            }),
        minLength: 8,
        "data-testid": "newPassword",
        className: "flex-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        id: "passwordCompare",
        label: text("lblConfirmPasswordField"),
        type: "password",
        onChange: (e)=>setPasswordChange((prev)=>({
                    ...prev,
                    passwordCompare: e.target.value
                })),
        onBlur: ()=>onChange({
                passwordChange: passwordChange
            }),
        "data-testid": "passwordCompare",
        className: "flex-1"
    }))));
}




parcelRequire("ioU8h");
var $5G3y7 = parcelRequire("5G3y7");

var $bLjZo = parcelRequire("bLjZo");

var $1IbJL = parcelRequire("1IbJL");

var $7dhC8 = parcelRequire("7dhC8");

var $jS4TD = parcelRequire("jS4TD");

var $2GMY2 = parcelRequire("2GMY2");
const $8f321f6d7ea1874e$var$SContainer = (0, $avNx5.default).div`
    width: 100%;
`;
const $8f321f6d7ea1874e$var$SForm = (0, $avNx5.default).form`
    display: flex;
    gap: 20px;
    flex-direction: column;
`;
const $8f321f6d7ea1874e$var$SRow = (0, $avNx5.default).div`
    display: flex;
    gap: 12px;

    &.alignSelf {
        align-self: flex-end;
    }

    @media (max-width: 500px) {
        flex-direction: column;
    }
`;
const $8f321f6d7ea1874e$var$SWrapper = (0, $avNx5.default).div`
    display: flex;
    gap: 12px;
    flex-direction: ${({ direction: direction })=>direction};
    justify-content: ${({ direction: direction })=>direction === "row" ? "space-between" : "center"};
`;
const $8f321f6d7ea1874e$var$SInput = (0, $avNx5.default).input`
    width: 175px;
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;

    @media (max-width: 500px) {
        width: 100%;
    }
`;
function $8f321f6d7ea1874e$export$b7b58f2e100445f7({ user: user, className: className, style: style }) {
    const text = (0, $1IbJL.default)();
    const dispatch = (0, $e19ko.useDispatch)();
    const { value: userDetails, apply: changeDetails } = (0, $2fIUB.default)(user);
    const [updateUser, { isLoading: isUpdating }] = (0, $2GMY2.useUserUpdateLoggedInUserMutation)();
    const [openPasswordChange, setOpenPasswordChange] = (0, $jGnJo.useState)(false);
    const [emptyFields, setEmptyFields] = (0, $jGnJo.useState)([]);
    const [updateMessage, setUpdateMessage] = (0, $jGnJo.useState)({
        message: null,
        type: null
    });
    const [passwordErrors, setPasswordErrors] = (0, $jGnJo.useState)("");
    const getUpdateErrorMessage = (error)=>{
        if ((0, $jS4TD.isFetchBaseQueryError)(error) && error.data && typeof error.data === "object" && "messageCode" in error.data && typeof error.data.messageCode === "string") return text(error.data.messageCode);
        return text("msgProfileNotUpdated");
    };
    const handlePasswordChangeVisibility = (isOpen)=>{
        setOpenPasswordChange(isOpen);
        if (!isOpen) changeDetails({
            passwordChange: null
        });
    };
    /** Update field **/ const updateField = (field, value)=>{
        changeDetails({
            [field]: value
        });
        const missingFields = [
            ...emptyFields.filter((m)=>m.field !== field)
        ];
        if (field === "firstName" && !value.length) missingFields.push({
            message: text("msgFirstNameRequired"),
            field: "firstName"
        });
        if (field === "lastName" && !value.length) missingFields.push({
            message: text("msgLastNameRequired"),
            field: "lastName"
        });
        if (field === "mobile" && !value.length) missingFields.push({
            message: text("msgMobileRequired"),
            field: "mobile"
        });
        setEmptyFields(missingFields);
        if (updateMessage.type) setUpdateMessage({
            type: null,
            message: null
        });
    };
    /** Check if new password is too short **/ (0, $jGnJo.useEffect)(()=>{
        if (userDetails.passwordChange?.newPassword && !(0, $angn7.isPasswordLongEnough)(userDetails.passwordChange.newPassword)) setPasswordErrors(text("msgPasswordToShort"));
        else setPasswordErrors("");
    }, [
        text,
        userDetails.passwordChange
    ]);
    /***************************************/ /** Check password before sending request **/ const checkPasswordChange = (passwordChange)=>{
        const currentPassword = passwordChange?.currentPassword ?? "";
        const newPassword = passwordChange?.newPassword ?? "";
        const passwordCompare = passwordChange?.passwordCompare ?? "";
        if (!currentPassword.length) {
            setPasswordErrors(text("lblCurrentPasswordEmptyField"));
            return true;
        }
        if (!(0, $angn7.isPasswordLongEnough)(newPassword)) {
            setPasswordErrors(text("msgPasswordToShort"));
            return true;
        }
        if (newPassword !== passwordCompare) {
            setPasswordErrors(text("msgPasswordFailedToUpdate"));
            return true;
        }
        return false;
    };
    /*******************************************/ /** Handle submit **/ const handleSubmit = async (e)=>{
        e.preventDefault();
        setUpdateMessage({
            message: null,
            type: null
        });
        if (openPasswordChange && checkPasswordChange(userDetails.passwordChange)) return;
        try {
            await updateUser({
                chargePointUser: userDetails
            }).unwrap();
            setUpdateMessage({
                message: openPasswordChange ? text("msgProfilePasswordUpdated") : text("msgProfileUpdated"),
                type: "Success"
            });
            dispatch((0, $7dhC8.setUser)(userDetails));
        } catch (error) {
            setUpdateMessage({
                message: getUpdateErrorMessage(error),
                type: "Error"
            });
        }
    };
    /*******************/ const widgetTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
        code: "lblMyProfileWidget",
        className: "myProfile"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SContainer, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bLjZo.WidgetLayout), {
        title: widgetTitle,
        "data-testid": "myProfile"
    }, emptyFields?.map((field, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5G3y7.Alert), {
            key: index,
            message: field.message,
            className: `${field.field}Error`,
            error: true
        })), passwordErrors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5G3y7.Alert), {
        message: passwordErrors,
        error: true,
        className: "passwordError"
    }), updateMessage.message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5G3y7.Alert), {
        message: updateMessage.message,
        error: updateMessage.type === "Error",
        className: updateMessage.message.includes("password is incorrect") ? "passwordError" : `update${updateMessage.type}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SForm, {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SInput, {
        className: "form-control",
        placeholder: text("lblFirstName"),
        type: "text",
        name: "firstName",
        onChange: (e)=>updateField("firstName", e.target.value),
        value: userDetails.firstName,
        id: "firstName",
        maxLength: 100,
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SInput, {
        className: "form-control",
        placeholder: text("lblLastNameField"),
        type: "text",
        name: "lastName",
        value: userDetails.lastName,
        onChange: (e)=>updateField("lastName", e.target.value),
        id: "lastName",
        maxLength: 100,
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SInput, {
        className: "form-control",
        placeholder: text("lblEmailAddressField"),
        type: "email",
        name: "email",
        value: user.email,
        required: true,
        readOnly: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SInput, {
        className: "form-control",
        placeholder: text("lblMobilePhoneField"),
        type: "text",
        name: "mobile",
        value: userDetails?.mobile,
        onChange: (e)=>updateField("mobile", e.target.value),
        id: "mobile",
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SWrapper, {
        direction: openPasswordChange ? "column" : "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $13384ffac91a0049$export$fb7f3eeb32bd6cd0), {
        user: userDetails,
        onChange: changeDetails,
        openPasswordChange: openPasswordChange,
        setOpenPasswordChange: handlePasswordChangeVisibility
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8f321f6d7ea1874e$var$SRow, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))({
            alignSelf: openPasswordChange
        })
    }, openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        label: text("btnCancel"),
        text: true,
        onClick: ()=>handlePasswordChangeVisibility(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "submit",
        label: text("btnSave"),
        icon: "pi pi-save",
        disabled: emptyFields.length > 0 || passwordErrors.length > 0,
        loading: isUpdating
    }))))));
}





var $jGnJo = parcelRequire("jGnJo");

var $g1rJs = parcelRequire("g1rJs");

var $1IbJL = parcelRequire("1IbJL");

var $lIzCm = parcelRequire("lIzCm");

var $uS5Zz = parcelRequire("uS5Zz");

var $eNXOe = parcelRequire("eNXOe");

var $dTa0r = parcelRequire("dTa0r");

var $2GMY2 = parcelRequire("2GMY2");

var $k6XqL = parcelRequire("k6XqL");

var $ijzRR = parcelRequire("ijzRR");

var $4wzzF = parcelRequire("4wzzF");

var $9c5en = parcelRequire("9c5en");

var $30QbC = parcelRequire("30QbC");
const $c151cb209ca5f6d7$var$formId = "edit-charge-point-form";
function $c151cb209ca5f6d7$export$666b8e5b12c29656(props) {
    const { chargePoint: chargePoint } = props;
    if (!chargePoint) return null;
    const DialogContent = chargePoint.isOcpp ? $c151cb209ca5f6d7$var$OcppEditChargePointDialogContent : $c151cb209ca5f6d7$var$CapiEditChargePointDialogContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement(DialogContent, {
        key: chargePoint.id,
        ...props,
        chargePoint: chargePoint
    });
}
function $c151cb209ca5f6d7$var$OcppEditChargePointDialogContent(props) {
    const validationMethods = (0, $eNXOe.useOcppUserCurrentValidation)(props.chargePoint);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($c151cb209ca5f6d7$var$EditChargePointForm, {
        ...props,
        validationMethods: validationMethods
    });
}
function $c151cb209ca5f6d7$var$CapiEditChargePointDialogContent(props) {
    const validationMethods = (0, $dTa0r.useCapiUserCurrentValidation)(props.chargePoint);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($c151cb209ca5f6d7$var$EditChargePointForm, {
        ...props,
        validationMethods: validationMethods
    });
}
function $c151cb209ca5f6d7$var$EditChargePointForm({ chargePoint: chargePoint, visible: visible, onHide: onHide, onSaveSettled: onSaveSettled, editChargerName: editChargerName, validationMethods: validationMethods }) {
    const text = (0, $1IbJL.default)();
    const toast = (0, $4wzzF.useToast)();
    const adaptConnectorNaming = (0, $lIzCm.useAdaptConnectorNaming)();
    const [edit, setEdit] = (0, $jGnJo.useState)(false);
    const availableConnectors = (chargePoint.connectors ?? []).filter((connector)=>(0, $9c5en.isChargingConnector)(connector) && (connector.connectorId === 1 || connector.connectorId === 2)).sort((a, b)=>a.connectorId - b.connectorId);
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { isValid: isValid, isDirty: isDirty, isSubmitted: isSubmitted } } = validationMethods;
    const title = (0, $uS5Zz.getProductName)(chargePoint.productId);
    const readOnlyReason = chargePoint.ownerReadOnly ? text("msgNoPermissionToEditCharger") : undefined;
    const [updateChargePointUserSettings, { isLoading: isSaving }] = (0, $2GMY2.useChargePointUpdateChargePointUserSettingsMutation)();
    (0, $jGnJo.useEffect)(()=>{
        if (visible) {
            reset();
            setEdit(false);
        }
    }, [
        reset,
        visible
    ]);
    const saveChargePoint = async (formValues)=>{
        try {
            await updateChargePointUserSettings({
                chargePointId: chargePoint.id,
                name: formValues.name ?? "",
                userCurrentConnector1: formValues.uc_1,
                userCurrentConnector2: formValues.uc_2
            }).unwrap();
            toast.notifySuccess(text("msgChargerUpdated"));
        } catch  {
            toast.notifyError(text("msgChargePointNotUpdated"));
        } finally{
            onHide();
            onSaveSettled?.();
        }
    };
    const saveDisabled = !isDirty || isSubmitted && !isValid || !(0, $30QbC.default)(chargePoint) || chargePoint.ownerReadOnly || isSaving;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        label: text("btnSave"),
        type: "submit",
        form: $c151cb209ca5f6d7$var$formId,
        disabled: saveDisabled,
        loading: isSaving
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $ijzRR.Dialog), {
        visible: visible,
        onHide: onHide,
        header: text("lblChargerInfoDialogTitle"),
        footer: footer,
        "data-testid": "edit-charge-point-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("form", {
        id: $c151cb209ca5f6d7$var$formId,
        className: "flex flex-column gap-4",
        onSubmit: handleSubmit(saveChargePoint),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("section", {
        className: "flex flex-column gap-3"
    }, edit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        type: "text",
        id: "name",
        label: text("lblName"),
        "data-testid": "name-input",
        required: true,
        ...register("name"),
        error: validationMethods.getFieldState("name").error?.message
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex align-items-center gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
        className: "text-xl font-medium"
    }, chargePoint.name), editChargerName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        icon: "pi pi-pencil",
        text: true,
        rounded: true,
        size: "small",
        severity: "info",
        disabled: chargePoint.ownerReadOnly,
        tooltip: readOnlyReason,
        tooltipOptions: {
            position: "top",
            showOnDisabled: true
        },
        "aria-label": text("lblEditChargerName"),
        onClick: ()=>setEdit(true),
        "data-testid": "toggle-name-edit"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex align-items-center gap-2 text-color-secondary",
        "data-testid": `chargePointType-${chargePoint.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", null, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", null, chargePoint.isOcpp ? text("lblOcpp") : text("lblCapiField")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("section", {
        className: "flex flex-column gap-3"
    }, availableConnectors.map((connector)=>{
        const fieldName = `uc_${connector.connectorId}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
            key: connector.connectorId,
            type: "number",
            id: fieldName,
            label: text("lblCurrentLimitWithMaxVoltage", {
                connectorName: adaptConnectorNaming(connector.name),
                installationCurrent: connector.installationCurrent
            }),
            "data-testid": `userCurrent-input-${connector.connectorId}`,
            error: validationMethods.getFieldState(fieldName).error?.message,
            ...register(fieldName),
            disabled: isSaving || chargePoint.ownerReadOnly || chargePoint.isOcpp && chargePoint.chargePointStatus !== "Online",
            disabledReason: readOnlyReason
        });
    }))));
}





var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $g1rJs = parcelRequire("g1rJs");

var $2p1p9 = parcelRequire("2p1p9");
parcelRequire("ioU8h");
var $5G3y7 = parcelRequire("5G3y7");

var $fzqPg = parcelRequire("fzqPg");

var $4WTDi = parcelRequire("4WTDi");
const $ecda59dc8b55f537$var$updateNfcTagsForCurrentUser = (tags)=>(0, $4WTDi.default)({
        method: "PUT",
        path: "/users/nfctags/own",
        body: tags
    });
var $ecda59dc8b55f537$export$2e2bcd8739ae039 = $ecda59dc8b55f537$var$updateNfcTagsForCurrentUser;



var $4WTDi = parcelRequire("4WTDi");
const $63ff9cc9037d2b79$var$loadLatestRejectedNfcForUser = ()=>(0, $4WTDi.default)({
        path: `/users/nfctags/rejected`
    });
var $63ff9cc9037d2b79$export$2e2bcd8739ae039 = $63ff9cc9037d2b79$var$loadLatestRejectedNfcForUser;



var $cseD4 = parcelRequire("cseD4");

var $bLjZo = parcelRequire("bLjZo");

var $4WTDi = parcelRequire("4WTDi");
const $94c91319f5e2cbdb$var$loadNfcTagsForCurrentUser = ()=>(0, $4WTDi.default)({
        path: "/users/nfctags/own"
    });
var $94c91319f5e2cbdb$export$2e2bcd8739ae039 = $94c91319f5e2cbdb$var$loadNfcTagsForCurrentUser;



var $1IbJL = parcelRequire("1IbJL");
const $0a0e58eee3f51651$var$SContainer = (0, $avNx5.default)((0, $bLjZo.WidgetLayout))`
    width: 100%;
`;
const $0a0e58eee3f51651$var$SForm = (0, $avNx5.default).form`
    display: flex;
    flex-direction: column;
`;
const $0a0e58eee3f51651$var$SRow = (0, $avNx5.default).div`
    display: flex;
    gap: 12px;
    margin-bottom: 20px;

    &.alignSelf {
        align-self: flex-end;
        margin-bottom: 0;
    }
`;
const $0a0e58eee3f51651$var$SInput = (0, $avNx5.default).input`
    width: 175px;
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
`;
function $0a0e58eee3f51651$export$4151436cdd5efa83({ className: className, style: style, rfid1: rfid1, rfid2: rfid2, rfid3: rfid3 }) {
    const text = (0, $1IbJL.default)();
    const validateHexCode = (hex)=>{
        if (![
            8,
            14,
            20
        ].includes(hex.length)) return {
            isValid: false,
            error: text("msgRFIDNotAccepted")
        };
        const isValid = /^[0-9A-Fa-f]+$/g.test(hex);
        return {
            isValid: isValid,
            error: !isValid && text("msgInvalidHexadecimal")
        };
    };
    const [rfidOne, setRfidOne] = (0, $jGnJo.useState)({
        id: "",
        comment: ""
    });
    const [rfidTwo, setRfidTwo] = (0, $jGnJo.useState)({
        id: "",
        comment: ""
    });
    const [rfidThree, setRfidThree] = (0, $jGnJo.useState)({
        id: "",
        comment: ""
    });
    const [rejectedTag, setRejectedTag] = (0, $jGnJo.useState)(null);
    const [tagMessage, setTagMessage] = (0, $jGnJo.useState)({
        type: null,
        message: null
    });
    const [tagError, setTagError] = (0, $jGnJo.useState)([]);
    (0, $jGnJo.useEffect)(()=>{
        setRfidOne({
            id: rfid1?.tagId ?? "",
            comment: rfid1?.tagComment ?? ""
        });
        setRfidTwo({
            id: rfid2?.tagId ?? "",
            comment: rfid2?.tagComment ?? ""
        });
        setRfidThree({
            id: rfid3?.tagId ?? "",
            comment: rfid3?.tagComment ?? ""
        });
    }, [
        rfid1,
        rfid2,
        rfid3
    ]);
    const loadRejectedTagsForUser = (0, $cseD4.default)(()=>(0, $63ff9cc9037d2b79$export$2e2bcd8739ae039)().catch(()=>Promise.reject("msgInstallationWizardExitWizardErrorHeading")), [], []);
    (0, $jGnJo.useEffect)(()=>{
        if (loadRejectedTagsForUser.status === (0, $cseD4.Status).SUCCESS) setRejectedTag(loadRejectedTagsForUser.value);
    }, [
        loadRejectedTagsForUser.status
    ]);
    const updateTagsForUser = (0, $cseD4.default)((tags)=>(0, $ecda59dc8b55f537$export$2e2bcd8739ae039)(tags).catch(()=>Promise.reject(text("msgRFIDTagsNotUpdated"))));
    (0, $jGnJo.useEffect)(()=>{
        if (updateTagsForUser.status === (0, $cseD4.Status).SUCCESS) {
            setTagMessage({
                type: "success",
                message: text("msgRFIDTagsUpdated")
            });
            setTimeout(()=>setTagMessage({
                    type: null,
                    message: null
                }), 3000);
            loadRejectedTagsForUser.execute().catch(()=>{});
            getNfcTags.execute().catch(()=>{});
        }
        if (updateTagsForUser.status === (0, $cseD4.Status).ERROR) {
            setTagMessage({
                type: "error",
                message: text("msgRFIDTagsNotUpdated")
            });
            setTimeout(()=>setTagMessage({
                    type: null,
                    message: null
                }), 3000);
        }
    }, [
        updateTagsForUser.status
    ]);
    /**Get tags **/ const getNfcTags = (0, $cseD4.default)(()=>(0, $94c91319f5e2cbdb$export$2e2bcd8739ae039)().catch(()=>Promise.reject()));
    (0, $jGnJo.useEffect)(()=>{
        if (getNfcTags.status === (0, $cseD4.Status).SUCCESS) {
            const tags = getNfcTags.value ?? [];
            setRfidOne({
                id: tags[0]?.id ?? "",
                comment: tags[0]?.comment ?? ""
            });
            setRfidTwo({
                id: tags[1]?.id ?? "",
                comment: tags[1]?.comment ?? ""
            });
            setRfidThree({
                id: tags[2]?.id ?? "",
                comment: tags[2]?.comment ?? ""
            });
        }
    }, [
        getNfcTags.status
    ]);
    /************/ const handleSubmit = (e)=>{
        e.preventDefault();
        const errors = [];
        if (rfidOne.id.length > 0) {
            const { isValid: isValid, error: error } = validateHexCode(rfidOne.id);
            if (!isValid) errors.push({
                type: rfidOne.id,
                message: error.toString()
            });
        }
        if (rfidTwo.id.length > 0) {
            const { isValid: isValid, error: error } = validateHexCode(rfidTwo.id);
            if (!isValid) errors.push({
                type: rfidTwo.id,
                message: error.toString()
            });
        }
        if (rfidThree.id.length > 0) {
            const { isValid: isValid, error: error } = validateHexCode(rfidThree.id);
            if (!isValid) errors.push({
                type: rfidThree.id,
                message: error.toString()
            });
        }
        if (errors.length) {
            setTagError(errors);
            return;
        }
        const nfcTags = [
            rfidThree,
            rfidTwo,
            rfidOne
        ];
        updateTagsForUser.execute(nfcTags).catch(()=>{});
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SContainer, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
            code: "lblRFIDWidget",
            dataTestId: "rfidHeader"
        }),
        "data-testid": "rfidContainer"
    }, tagMessage.message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5G3y7.Alert), {
        message: tagMessage.message,
        error: tagMessage.type === "error" ? true : false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SForm, {
        onSubmit: handleSubmit
    }, tagError.find((t)=>t.type === rfidOne.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5G3y7.Alert), {
        message: tagError.find((t)=>t.type === rfidOne.id)?.message ?? "",
        error: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SInput, {
        className: "form-control",
        placeholder: text("lblRFIDTagId"),
        type: "text",
        maxLength: 100,
        value: rfidOne.id,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidOne({
                ...rfidOne,
                id: value
            });
        },
        "data-testid": "tag1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SInput, {
        className: "form-control",
        placeholder: text("lblCommentForTagOneField"),
        type: "text",
        maxLength: 100,
        value: rfidOne.comment,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidOne({
                ...rfidOne,
                comment: value
            });
        },
        "data-testid": "comment1"
    })), tagError.find((t)=>t.type === rfidTwo.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5G3y7.Alert), {
        message: tagError.find((t)=>t.type === rfidTwo.id)?.message ?? "",
        error: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SInput, {
        className: "form-control",
        placeholder: text("lblRFIDTagId"),
        type: "text",
        maxLength: 100,
        value: rfidTwo.id,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidTwo({
                ...rfidTwo,
                id: value
            });
        },
        "data-testid": "tag2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SInput, {
        className: "form-control",
        placeholder: text("lblCommentForTagTwoField"),
        type: "text",
        maxLength: 100,
        value: rfidTwo.comment,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidTwo({
                ...rfidTwo,
                comment: value
            });
        },
        "data-testid": "comment2"
    })), tagError.find((t)=>t.type === rfidThree.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5G3y7.Alert), {
        message: tagError.find((t)=>t.type === rfidThree.id)?.message ?? "",
        error: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SInput, {
        className: "form-control",
        placeholder: text("lblRFIDTagId"),
        type: "text",
        maxLength: 100,
        value: rfidThree.id,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidThree({
                ...rfidThree,
                id: value
            });
        },
        "data-testid": "tag3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SInput, {
        className: "form-control",
        placeholder: text("lblCommentForTagThreeField"),
        type: "text",
        maxLength: 100,
        value: rfidThree.comment,
        onInput: (e)=>{
            const value = e.target.value;
            setRfidThree({
                ...rfidThree,
                comment: value
            });
        },
        "data-testid": "comment3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0a0e58eee3f51651$var$SRow, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))({
            alignSelf: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "submit",
        label: text("btnSave"),
        icon: "pi pi-save",
        loading: updateTagsForUser.status === (0, $cseD4.Status).PENDING,
        disabled: updateTagsForUser.status === (0, $cseD4.Status).PENDING,
        "data-testid": "sumbitBtn"
    })), rejectedTag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblLastRejectedTag",
        values: {
            latestRejected: rejectedTag
        }
    })));
}





var $24XaJ = parcelRequire("24XaJ");

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $g1rJs = parcelRequire("g1rJs");

var $2p1p9 = parcelRequire("2p1p9");

var $fzqPg = parcelRequire("fzqPg");

var $bLjZo = parcelRequire("bLjZo");

var $6xN58 = parcelRequire("6xN58");

var $30QbC = parcelRequire("30QbC");

var $1IbJL = parcelRequire("1IbJL");

var $c9CVP = parcelRequire("c9CVP");

var $6Bp5U = parcelRequire("6Bp5U");

var $jGnJo = parcelRequire("jGnJo");

var $jzUeY = parcelRequire("jzUeY");

var $g1rJs = parcelRequire("g1rJs");

var $ijzRR = parcelRequire("ijzRR");

var $k6XqL = parcelRequire("k6XqL");

var $4wzzF = parcelRequire("4wzzF");

var $ercFZ = parcelRequire("ercFZ");

var $jS4TD = parcelRequire("jS4TD");

var $2GMY2 = parcelRequire("2GMY2");

var $1IbJL = parcelRequire("1IbJL");
const $0c1aa8c4eeffc2c6$var$formId = "add-charge-point-form";
function $0c1aa8c4eeffc2c6$export$58199e6f500a92fe({ visible: visible, onHide: onHide, userId: userId }) {
    const text = (0, $1IbJL.default)();
    const toast = (0, $4wzzF.useToast)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting, isValid: isValid } } = (0, $jzUeY.useForm)({
        defaultValues: {
            chargePointId: "",
            name: "",
            wifiPassword: ""
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    const nameLength = (0, $jzUeY.useWatch)({
        control: control,
        name: "name",
        defaultValue: ""
    }).trim().length;
    const [addChargerToUser, { isLoading: isLoading }] = (0, $2GMY2.useChargePointSetOwnerMutation)();
    (0, $jGnJo.useEffect)(()=>{
        if (visible) reset();
    }, [
        reset,
        visible
    ]);
    const doAddChargerToUser = async (formValues)=>{
        const name = formValues.name.trim();
        try {
            await addChargerToUser({
                userId: userId,
                chargePointId: formValues.chargePointId,
                name: name || formValues.chargePointId,
                wifiPassword: formValues.wifiPassword
            }).unwrap();
            toast.notifySuccess(text("msgChargerWasSuccessfullyAdded"));
            onHide();
        } catch (error) {
            if ((0, $jS4TD.isFetchBaseQueryError)(error) && (error.status === 409 || error.status === 404 || error.status === 403) && error.data && error.data.error) toast.notifyError(error.data.error);
            else toast.notifyError(text("msgChargerNotAddedtoUser"));
        }
    };
    const submitDisabled = isLoading || isSubmitting || isSubmitted && !isValid;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        label: text("btnAddChargerToUser"),
        type: "submit",
        form: $0c1aa8c4eeffc2c6$var$formId,
        disabled: submitDisabled,
        loading: isLoading || isSubmitting
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $ijzRR.Dialog), {
        "data-testid": "add-charge-point-dialog",
        header: text("lblAddChargerToUserDialogTitle"),
        visible: visible,
        onHide: onHide,
        footer: footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("form", {
        id: $0c1aa8c4eeffc2c6$var$formId,
        "data-testid": "create-modal-form",
        onSubmit: handleSubmit(doAddChargerToUser),
        className: "flex flex-column gap-3",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        id: "serialNumber",
        label: text("lblSerialNumberField"),
        ...register("chargePointId", {
            required: text("msgAddChargePointSerialNumberRequired")
        }),
        error: errors.chargePointId?.message,
        "data-testid": "serialNumber",
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        id: "pinCode",
        label: text("lblPin"),
        ...register("wifiPassword", {
            required: text("msgPinCodeRequired")
        }),
        error: errors.wifiPassword?.message,
        "data-testid": "pinCode",
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $k6XqL.Input), {
        id: "name",
        label: text("lblName"),
        ...register("name", {
            validate: (value)=>value.trim().length <= (0, $ercFZ.MAX_NAME_LENGTH) || text("lblNameError")
        }),
        error: errors.name?.message,
        subtitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
            className: "flex justify-content-end"
        }, text("msgTextAreaCounter", {
            textCount: nameLength,
            maxLength: (0, $ercFZ.MAX_NAME_LENGTH)
        })),
        "data-testid": "name"
    })));
}




const $0fceb8d7629c235a$var$StatusIcon = (0, $avNx5.default).span`
    margin-left: 10px;
`;
function $0fceb8d7629c235a$export$cda9f498fc59d764({ className: className, style: style, chargePoints: chargePoints, loading: loading, removeChargePoint: removeChargePoint, editChargePoint: editChargePoint, user: user }) {
    const text = (0, $1IbJL.default)();
    const [showAddChargePoint, setShowAddChargePoint] = (0, $jGnJo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bLjZo.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
            code: "lblMyChargersWidget"
        }),
        "data-testid": "myChargers",
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
            onClick: ()=>setShowAddChargePoint(true),
            "data-testid": "showAddChargePoint",
            label: text("btnAdd"),
            icon: "pi pi-plus"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblStatus"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), {
        "data-testid": "serialNumber"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblSerialNumber"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), {
        "data-testid": "name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), null))), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBody), null, chargePoints && chargePoints.map((chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableRow), {
            key: chargePoint.id,
            className: "clickable"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($0fceb8d7629c235a$var$StatusIcon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))("fa fa-wifi", (0, $30QbC.default)(chargePoint) ? "greenFont" : "redFont"),
            title: text((0, $30QbC.default)(chargePoint) ? "lblOnline" : "lblOffline")
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), null, chargePoint.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), {
            "data-testid": `name-${chargePoint.name}`
        }, chargePoint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
            className: "flex justify-content-end gap-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
            size: "small",
            icon: "pi pi-pencil",
            rounded: true,
            outlined: true,
            severity: "info",
            "aria-label": text("lblEditChargerName"),
            onClick: ()=>{
                editChargePoint(chargePoint);
            },
            "data-testid": "edit-button"
        }), !chargePoint.ownerReadOnly && !chargePoint.companyId && chargePoint.ownerId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
            size: "small",
            icon: "pi pi-trash",
            rounded: true,
            outlined: true,
            severity: "danger",
            onClick: ()=>{
                removeChargePoint(chargePoint.id);
            },
            "data-testid": "remove-button"
        }), chargePoint.ownerReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $c9CVP.default), {
            content: "msgChargerCanOnlyBeModifiedByAdministrators"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6Bp5U.InfoIcon), {
            size: 25,
            "data-testid": "tooltipIcon"
        }))))))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "shimmer-container shimmer-xsmall margin-bottom-small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $0c1aa8c4eeffc2c6$export$58199e6f500a92fe), {
        visible: showAddChargePoint,
        onHide: ()=>setShowAddChargePoint(false),
        userId: user.id
    }));
}




parcelRequire("5gIXE");
var $8Z9am = parcelRequire("8Z9am");

var $2GMY2 = parcelRequire("2GMY2");

var $fv8x4 = parcelRequire("fv8x4");

var $1IbJL = parcelRequire("1IbJL");

var $7CxMf = parcelRequire("7CxMf");

var $j7d1a = parcelRequire("j7d1a");
function $b1d338bb17cffa87$export$3bf6356b6e1d6999() {
    const text = (0, $1IbJL.default)();
    const user = (0, $e19ko.useSelector)((state)=>state.user);
    const [selectedChargePoint, setSelectedChargePoint] = (0, $jGnJo.useState)(null);
    const { data: isCompanyMember, isLoading: loadingCompanyMember } = (0, $2GMY2.useUserLoggedInUserIsCompanyMemberQuery)();
    const { data: userChargePoints, refetch: refetch, isLoading: chargePointLoading } = (0, $2GMY2.useUserGetOwnedChargePointsQuery)({
        expand: (0, $j7d1a.default).OcppConfig
    });
    const [removeChargePoint] = (0, $2GMY2.useUserRemoveChargePointAccessMutation)();
    const anyOcppEnabled = userChargePoints?.some((chargePoint)=>chargePoint.ocppEnabled) ?? false;
    const handleRemoveCharger = async (chargePointId)=>{
        if (!chargePointId) return;
        const confirmed = await (0, $7CxMf.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgRemoveCharger"),
            variant: "danger"
        });
        if (!confirmed) return;
        try {
            await removeChargePoint({
                chargePointId: chargePointId
            }).unwrap();
            (0, $fv8x4.notifySuccess)(text("msgChargerWasSuccessfullyRemoved"));
        } catch  {
            (0, $fv8x4.notifyError)(text("msgChargerFailedToRemove"));
        }
    };
    const { data: tags, isLoading: loadingNfcTag } = (0, $2GMY2.useUserGetOwnNfcTagsQuery)();
    const rfidTags = tags?.map((tag)=>({
            tagId: tag.id ?? "",
            tagComment: tag.comment ?? ""
        })) ?? [];
    if (!user) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
        code: "lblProfile",
        className: "profilePage",
        size: "lg",
        "data-testid": "header-profile"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-6 margin-top-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8f321f6d7ea1874e$export$b7b58f2e100445f7), {
        user: user
    }), !loadingCompanyMember && !isCompanyMember && !anyOcppEnabled && (loadingNfcTag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8Z9am.WidgetLoadingState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $0a0e58eee3f51651$export$4151436cdd5efa83), {
        rfid1: rfidTags[0],
        rfid2: rfidTags[1],
        rfid3: rfidTags[2]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-6 margin-top-small"
    }, chargePointLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8Z9am.WidgetLoadingState), {
        height: "162px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $0fceb8d7629c235a$export$cda9f498fc59d764), {
        chargePoints: userChargePoints,
        removeChargePoint: handleRemoveCharger,
        editChargePoint: setSelectedChargePoint,
        loading: chargePointLoading,
        user: user
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $24XaJ.UserProfileLanguageSelect), {
        userId: user.id
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $c151cb209ca5f6d7$export$666b8e5b12c29656), {
        chargePoint: selectedChargePoint,
        visible: Boolean(selectedChargePoint),
        onHide: ()=>setSelectedChargePoint(null),
        onSaveSettled: ()=>refetch(),
        editChargerName: true
    }));
}





var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $6B1WO = parcelRequire("6B1WO");

var $2p1p9 = parcelRequire("2p1p9");

var $2GMY2 = parcelRequire("2GMY2");

var $j7d1a = parcelRequire("j7d1a");

var $bLjZo = parcelRequire("bLjZo");

var $1r1pk = parcelRequire("1r1pk");

var $fzqPg = parcelRequire("fzqPg");

var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $2iEO8 = parcelRequire("2iEO8");

var $dC4es = parcelRequire("dC4es");
const $d22159428bca840c$var$SExpandElementContainer = (0, $avNx5.default).div`
    display: flex;
    margin-top: 30px;
`;
const $d22159428bca840c$var$STitleContainer = (0, $avNx5.default).div`
    width: 200px;
`;
const $d22159428bca840c$var$SChevronContainer = (0, $avNx5.default).div`
    padding-top: 3px;
    margin-left: 20px;
`;
const $d22159428bca840c$var$STitleText = (0, $avNx5.default).label`
    width: 200px;
    font-size: 21px;
    font-weight: var(--font-weight-bold);
    line-height: 28px;
    margin-bottom: 0px;
    display: block;
    word-wrap: break-word;
`;
const $d22159428bca840c$var$SSubTitleText = (0, $avNx5.default).label`
    font-size: 21px;
    font-weight: var(--font-weight-light);
    line-height: 28px;
    margin-bottom: 0px;
    word-wrap: break-word;
`;
const $d22159428bca840c$var$PartnerInfoItem = ({ name: name, email: email, phone: phone, chargerName: chargerName, chargerSerialNumber: chargerSerialNumber })=>{
    const [isExpanded, setIsExpanded] = (0, $jGnJo.useState)(false);
    if (!chargerSerialNumber) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($d22159428bca840c$var$SExpandElementContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($d22159428bca840c$var$STitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($d22159428bca840c$var$STitleText, {
        "data-testid": "title-text-charger-name-partner-info"
    }, chargerName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($d22159428bca840c$var$SSubTitleText, {
        "data-testid": "subtitle-text-charger-serial-number-partner-info"
    }, chargerSerialNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($d22159428bca840c$var$SChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2iEO8.default), {
        flipped: isExpanded,
        onClick: ()=>setIsExpanded((prev)=>!prev)
    }))), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $dC4es.default), {
        name: name,
        email: email,
        phone: phone
    }) : null);
};
var $d22159428bca840c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jGnJo.memo)($d22159428bca840c$var$PartnerInfoItem);



var $dC4es = parcelRequire("dC4es");

var $1IbJL = parcelRequire("1IbJL");
const $16e8a7738846a334$var$SSupportDetailsMessage = (0, $avNx5.default).label`
    font-size: 16px;
    line-height: 24px;
    display: block;
    margin-bottom: 40px;
`;
const $16e8a7738846a334$export$612b9760953b2c71 = ()=>{
    const text = (0, $1IbJL.default)();
    const { data: chargePoints, isLoading: isLoading } = (0, $2GMY2.useUserGetOwnedChargePointsQuery)({
        expand: (0, $j7d1a.default).PartnerInfo
    });
    const chargersWithPartnerInfo = chargePoints?.filter((charger)=>charger.partnerInfo) ?? [];
    const renderItem = ()=>{
        if (chargersWithPartnerInfo.length === 0) return null;
        if (chargersWithPartnerInfo.length === 1) {
            const partnerInfo = chargersWithPartnerInfo[0].partnerInfo;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $dC4es.default), {
                name: partnerInfo?.name,
                email: partnerInfo?.email,
                phone: partnerInfo?.phone
            });
        } else return chargersWithPartnerInfo.map((charger)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $d22159428bca840c$export$2e2bcd8739ae039), {
                key: charger.id,
                name: charger.partnerInfo?.name,
                email: charger.partnerInfo?.email,
                phone: charger.partnerInfo?.phone,
                chargerName: charger.name ?? charger.id,
                chargerSerialNumber: charger.id
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6B1WO.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
        code: "lblSupport",
        className: "supportPage",
        size: "lg",
        dataTestId: "header-support"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-7 margin-top-small"
    }, !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bLjZo.WidgetLayout), null, chargersWithPartnerInfo.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "margin-bottom-large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($16e8a7738846a334$var$SSupportDetailsMessage, {
        "data-testid": "support-details-message"
    }, text("msgDetailsOfSupportProvider")), renderItem()) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblFaq"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $1r1pk.default), {
        dataTestId: "link-charge-amps-support-page",
        titleCode: "lblChargeAmpsSupportPage",
        href: `https://www.chargeamps.com/${text("linkSupport")}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $1r1pk.default), {
        dataTestId: "link-charge-amps-help-center-page",
        titleCode: "lblChargeAmpsHelpCenter",
        href: text("linkHelpCenter")
    }))) : null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "shimmer-container shimmer-large",
        "data-testid": "loader"
    }))));
};





var $jGnJo = parcelRequire("jGnJo");

var $avNx5 = parcelRequire("avNx5");

var $4aBRs = parcelRequire("4aBRs");

var $2p1p9 = parcelRequire("2p1p9");

var $cseD4 = parcelRequire("cseD4");


var $a3vgd = parcelRequire("a3vgd");

var $4WTDi = parcelRequire("4WTDi");
const $44cdec56f364b235$var$loadChargerUsage = (userId)=>(0, $4WTDi.default)({
        path: `/stats/users/${userId}/chargerusage`
    });
var $44cdec56f364b235$export$2e2bcd8739ae039 = $44cdec56f364b235$var$loadChargerUsage;



var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");
const $96663aa56f9949e1$export$eb7dd588cfd00544 = [
    "#8ABFFF",
    "#DDDDDD",
    "#FF8B7C",
    "#006EF0",
    "#178B17",
    "#535353",
    "#DF0017"
];




const $8e6ea011eec4e89b$var$Wrapper = (0, $avNx5.default).div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const $8e6ea011eec4e89b$var$LabelContainer = (0, $avNx5.default).div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    top: 50px;
    right: 0;
    position: absolute;
    max-width: 100px;
    hyphens: auto;
    text-align: left;

    @media screen and (max-width: 1095px) {
        position: relative;
        align-self: flex-start;
        max-width: 200px;
        hyphens: auto;
    }
`;
const $8e6ea011eec4e89b$var$Dot = (0, $avNx5.default).div`
    height: 11px;
    width: 11px;
    margin: 1px 4px;
    background-color: ${({ color: color })=>color};
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
`;
const $8e6ea011eec4e89b$var$Label = (0, $avNx5.default).span`
    font-size: 14px;
    display: flex;
    transition: 0.2s all ease;
    color: ${({ theme: theme })=>theme.font.darkestColor};

    &.selected {
        ${$8e6ea011eec4e89b$var$Dot} {
            filter: opacity(70%);
        }
        text-decoration: underline;
    }

    &:hover {
        cursor: default;
    }
`;
const $8e6ea011eec4e89b$var$Path = (0, $avNx5.default).path`
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: dash 1.5s linear forwards;
    transition: 0.2s all ease;

    &:hover {
        filter: opacity(70%);
        cursor: pointer;
    }

    @keyframes dash {
        to {
            stroke-dashoffset: 0;
        }
    }
`;
const $8e6ea011eec4e89b$var$Text = (0, $avNx5.default).span`
    position: absolute;
    font-size: 24px;
`;
function $8e6ea011eec4e89b$var$Donut(cx, cy, radius, data) {
    if (!data) return;
    function arcradius(cx, cy, radius, degrees) {
        const radians = (degrees - 90) * Math.PI / 180.0;
        return {
            x: cx + radius * Math.cos(radians),
            y: cy + radius * Math.sin(radians)
        };
    }
    let total = 0;
    const arr = [];
    let beg = 0;
    let end = 0;
    let count = 0;
    for(let i = 0; i < data.length; i++)total += data[i].percentage;
    for(let i = 0; i < data.length; i++){
        const item = data[i];
        const tmp = {
            index: 0,
            value: 0,
            d: "",
            text: ""
        };
        let p = Math.floor((item.percentage + 1) / total * 100);
        count += p;
        if (i === length - 1 && count < 100) p = p + (100 - count);
        end = beg + 3.6 * p;
        tmp.index = i;
        tmp.value = item.percentage;
        const b = arcradius(cx, cy, radius, end);
        const e = arcradius(cx, cy, radius, beg);
        const la = end - beg <= 180 ? 0 : 1;
        tmp.d = [
            "M",
            Math.floor(b.x),
            Math.floor(b.y),
            "A",
            radius,
            radius,
            0,
            la,
            0,
            i === 0 ? Math.floor(e.x) + 7 : Math.floor(e.x),
            Math.floor(e.y)
        ].join(" ");
        tmp.text = item.chargePointName;
        arr.push(tmp);
        beg = end;
    }
    return arr;
}
const $8e6ea011eec4e89b$export$f19986a384ea910d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).memo(function DoughnutChart({ className: className, style: style, data: data }) {
    const centerX = 100;
    const centerY = 100;
    const radius = 70;
    const [showInfo, setShowInfo] = (0, $jGnJo.useState)({
        text: "",
        label: ""
    });
    const arr = $8e6ea011eec4e89b$var$Donut(centerX, centerY, radius, data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8e6ea011eec4e89b$var$Wrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8e6ea011eec4e89b$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("svg", {
        id: "svg",
        width: "200",
        height: "200"
    }, arr?.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("g", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8e6ea011eec4e89b$var$Path, {
            d: p.d,
            stroke: (0, $96663aa56f9949e1$export$eb7dd588cfd00544)[i],
            fill: "none",
            strokeWidth: "25",
            onMouseEnter: ()=>setShowInfo({
                    text: `${p.value}%`,
                    label: p.text
                }),
            onMouseLeave: ()=>setShowInfo({
                    text: "",
                    label: ""
                }),
            "data-testid": "path-" + p.text
        })))), showInfo.text.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8e6ea011eec4e89b$var$Text, {
        "data-testid": "percentage-text"
    }, showInfo.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8e6ea011eec4e89b$var$LabelContainer, null, arr?.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8e6ea011eec4e89b$var$Label, {
            key: p.text,
            color: (0, $96663aa56f9949e1$export$eb7dd588cfd00544)[i],
            className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))({
                selected: showInfo.label === p.text
            }),
            "data-testid": "label-" + p.text
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($8e6ea011eec4e89b$var$Dot, {
            color: (0, $96663aa56f9949e1$export$eb7dd588cfd00544)[i]
        }), p.text))));
});





var $fzqPg = parcelRequire("fzqPg");

var $jGnJo = parcelRequire("jGnJo");

var $g1rJs = parcelRequire("g1rJs");

var $2p1p9 = parcelRequire("2p1p9");

var $3utsp = parcelRequire("3utsp");

var $1IbJL = parcelRequire("1IbJL");

var $jGnJo = parcelRequire("jGnJo");

var $g1rJs = parcelRequire("g1rJs");

var $1IbJL = parcelRequire("1IbJL");

var $ijzRR = parcelRequire("ijzRR");

var $fzqPg = parcelRequire("fzqPg");
const $ac62cc6d3c3c358a$export$2a9b515c57b6776b = ({ visible: visible, onHide: onHide })=>{
    const text = (0, $1IbJL.default)();
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        label: text("btnCancel"),
        text: true,
        onClick: onHide
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $ijzRR.Dialog), {
        visible: visible,
        onHide: onHide,
        header: text("btnHelp"),
        footer: footer,
        "data-testid": "statistics-help-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgStatisticsHelp"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("p", {
        className: "mb-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgStatisticHelpDownload"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
        className: "inline-flex align-items-center ml-1 p-1 border-round bg-primary text-primary-color"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
        className: "pi pi-download"
    }))));
};




const $86d865a47667ff47$export$8ff0b497c55bd560 = /*#__PURE__*/ (0, $jGnJo.memo)(function UserAppStatisticsTotalConsumptionWidget({ download: download, downloadLoading: downloadLoading, reloadChart: reloadChart, data: data, useMonth: useMonth }) {
    const text = (0, $1IbJL.default)();
    const [showInfo, setShowInfo] = (0, $jGnJo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex align-items-center justify-content-center gap-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
        code: "lblTotalConsumption",
        dataTestId: "total-consumtion-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        size: "small",
        label: text("msgDownloadAsCSV"),
        icon: "pi pi-download",
        tooltip: text("msgDownloadAsCSV"),
        tooltipOptions: {
            position: "top"
        },
        loading: downloadLoading,
        onClick: download,
        "data-testid": "download"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $g1rJs.Button), {
        type: "button",
        size: "small",
        label: text("btnHelp"),
        icon: "pi pi-question-circle",
        outlined: true,
        tooltip: text("btnHelp"),
        tooltipOptions: {
            position: "top"
        },
        onClick: ()=>setShowInfo(true)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row flex justify-content-end mt-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("select", {
        className: "form-control",
        onChange: (e)=>reloadChart(e.target.value),
        required: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("option", {
        value: "currentmonth"
    }, text("msgThisMonthOption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("option", {
        value: "lastmonth"
    }, text("msgLastMonthOption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("option", {
        value: "currentyear"
    }, text("msgThisYearOption")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("option", {
        value: "lastyear"
    }, text("msgLastYearOption"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $3utsp.BarChart), {
        barChartId: "dygraphStatistic",
        data: data,
        useMonth: useMonth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $ac62cc6d3c3c358a$export$2a9b515c57b6776b), {
        visible: showInfo,
        onHide: ()=>setShowInfo(false)
    }));
});





var $4WTDi = parcelRequire("4WTDi");
const $2714ba59119a0398$var$loadReportForUser = (reportId, chargePointUserId, interval, timeZone)=>(0, $4WTDi.default)({
        path: `/reports/${reportId}`,
        query: {
            chargePointUserId: chargePointUserId,
            interval: interval,
            timeZone: timeZone
        }
    });
var $2714ba59119a0398$export$2e2bcd8739ae039 = $2714ba59119a0398$var$loadReportForUser;



var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $bLjZo = parcelRequire("bLjZo");

var $fzqPg = parcelRequire("fzqPg");

var $6xN58 = parcelRequire("6xN58");

var $1IbJL = parcelRequire("1IbJL");
function $bd5b8d943283baba$export$fce5dc8b070767c({ devices: devices, className: className, style: style }) {
    const text = (0, $1IbJL.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bLjZo.WidgetLayout), {
        title: text("lblMeasurementDeviceProperties"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblDescription"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblActive"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblMaxCurrent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblStatus"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBody), null, devices?.map((device)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableRow), {
            key: Math.random()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), {
            "data-testid": "deviceName"
        }, device.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), {
            "data-testid": "deviceDescription"
        }, device.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), null, device.active?.toString() ?? ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), null, device.loadBalancerGroupSupplyMaxCurrent || "---", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
            code: "lblAmpereShort"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6xN58.TableBodyCell), null, device.status))))));
}





var $54KBj = parcelRequire("54KBj");
parcelRequire("5gIXE");
var $8Z9am = parcelRequire("8Z9am");

var $2GMY2 = parcelRequire("2GMY2");

var $1IbJL = parcelRequire("1IbJL");

var $5wiCS = parcelRequire("5wiCS");
const $38369ead53bd3aff$var$Container = (0, $avNx5.default).div`
    display: flex;
    flex-direction: column;
    gap: 56px;
`;
const $38369ead53bd3aff$export$bacd47cfcd142d32 = /*#__PURE__*/ (0, $jGnJo.memo)(function UserAppStatisticPage({ style: style }) {
    const text = (0, $1IbJL.default)();
    const user = (0, $5wiCS.useSessionUser)();
    const userId = user.id;
    const [chargingSessionsOffset, setChargingSessionsOffset] = (0, $jGnJo.useState)(0);
    const [charginsSessions, setChargingSessions] = (0, $jGnJo.useState)([]);
    const [selectedInterval, setSelectedInterval] = (0, $jGnJo.useState)("currentmonth");
    const [loadingDownload, setLoadingDownload] = (0, $jGnJo.useState)(false);
    /** Get charging sessions **/ const { data: chargingSessionsData, isFetching: loadingChargingSessions } = (0, $2GMY2.useChargingSessionGetChargingSessionsForCurrentUserQuery)({
        offset: chargingSessionsOffset,
        noOfItems: (0, $96e348eb88b13195$export$c9346c8390d51ce8)
    });
    (0, $jGnJo.useEffect)(()=>{
        if (chargingSessionsData) setChargingSessions((currentSessions)=>currentSessions.length ? currentSessions.concat(chargingSessionsData) : chargingSessionsData);
    }, [
        chargingSessionsData
    ]);
    const loadMoreSessions = ()=>{
        setChargingSessionsOffset((currentOffset)=>currentOffset + (0, $96e348eb88b13195$export$c9346c8390d51ce8));
    };
    /***************************/ /** Get user statistics **/ const { data: userStatistic } = (0, $2GMY2.useStatisticsGetUserUsageStatisticsQuery)({
        userId: userId
    }, {
        skip: !userId
    });
    /************************/ /** Get charger usage **/ const getChargerUsage = (0, $cseD4.default)((userId)=>{
        if (userId) return (0, $44cdec56f364b235$export$2e2bcd8739ae039)(userId);
    }, [], [
        user?.id
    ]);
    /***********************/ /** get user total consumption **/ const { data: totalConsumtionData, isLoading: loadingConsumption } = (0, $2GMY2.useStatisticsGetUserTotalConsumptionQuery)({
        userId: userId,
        interval: selectedInterval
    }, {
        skip: !userId
    });
    /********************************/ /** Download data **/ const downloadData = ()=>{
        if (!userId) return;
        setLoadingDownload(true);
        const tz = (0, (/*@__PURE__*/$parcel$interopDefault($4aBRs))).determine();
        const timeZone = tz.name();
        let fileName = "";
        switch(selectedInterval){
            case "currentmonth":
                fileName = text("msgThisMonthOption");
                break;
            case "lastmonth":
                fileName = text("msgLastMonthOption");
                break;
            case "currentyear":
                fileName = text("msgThisYearOption");
                break;
            default:
                fileName = text("msgLastYearOption");
                break;
        }
        (0, $2714ba59119a0398$export$2e2bcd8739ae039)(100, user.id, selectedInterval, timeZone).then((report)=>{
            let csvData = "\uFEFF" + report.formattedData;
            if (!report.formattedData || report.formattedData.length === 0) csvData = "\uFEFFN/A";
            const file = new Blob([
                csvData
            ], {
                type: "application/txt"
            });
            const anchor = Object.assign(document.createElement("a"), {
                href: URL.createObjectURL(file),
                target: "_blank",
                download: fileName + ".csv",
                style: "display: none"
            });
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            setLoadingDownload(false);
        }, ()=>{
            console.error("could not load report data");
        });
    };
    /*******************/ const { data: measurementDevices = [], isFetching: isFetching } = (0, $2GMY2.useMeasurementDevicesGetDevicesByUserIdQuery)({
        userId: userId
    }, {
        skip: !userId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "page-layout-container",
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $2p1p9.Header), {
        code: "lblStatistics",
        size: "lg",
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row margin-bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($38369ead53bd3aff$var$Container, {
        className: "col-xs-12 col-md-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $86d865a47667ff47$export$8ff0b497c55bd560), {
        download: ()=>downloadData(),
        downloadLoading: loadingDownload,
        reloadChart: (type)=>{
            setSelectedInterval(type);
        },
        data: totalConsumtionData ?? [],
        useMonth: selectedInterval === "currentyear" || selectedInterval === "lastyear"
    }), loadingConsumption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8Z9am.WidgetLoadingState), {
        height: "360px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $96e348eb88b13195$export$d96ee243323785bc), {
        sessions: charginsSessions,
        showEndTime: true,
        loadMoreChargingSessions: ()=>loadMoreSessions(),
        loading: loadingChargingSessions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-4 margin-top-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("span", {
        className: "dashboard-graph"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblMostFrequentChargers"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8e6ea011eec4e89b$export$f19986a384ea910d), {
        data: getChargerUsage.value ?? []
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $a3vgd.ChargingStatistics), {
        stats: userStatistic,
        direction: "column"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "col-xs-12 col-md-6"
    }, isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8Z9am.WidgetLoadingState), {
        height: "200px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bd5b8d943283baba$export$fce5dc8b070767c), {
        devices: measurementDevices
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $54KBj.LoadBalancerStatistics), {
        device: measurementDevices?.[0]
    }));
});





var $jGnJo = parcelRequire("jGnJo");

var $jUW5l = parcelRequire("jUW5l");
const $13ebc6589c81ffff$export$a4bf597a1fb62466 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $jUW5l.ChargePointSchedulesPage), null));





var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $eqYah = parcelRequire("eqYah");
const $0f76b278a70c1e69$var$MENU_LINKS = [
    {
        href: "/dashboard",
        labelCode: "btnHome"
    },
    {
        href: "/user-profile",
        labelCode: "lblProfile"
    },
    {
        href: "/statistics",
        labelCode: "lblStatistics"
    },
    {
        href: "/remotecontrol",
        labelCode: "btnRemoteControl"
    },
    {
        href: "/support",
        labelCode: "lblSupport"
    }
];
function $0f76b278a70c1e69$export$6e8e699acb89c2ad({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $eqYah.PageHeader), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        links: $0f76b278a70c1e69$var$MENU_LINKS
    });
}




const $493a928b246bcebc$var$RequireAuth = ({ children: children, isHeaderShown: isHeaderShown = true, sessionStatus: sessionStatus })=>{
    const location = (0, $gCMx8.useLocation)();
    if (sessionStatus === "loading") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8UPmf.PortalSessionLoader), null);
    return sessionStatus === "authenticated" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", null, isHeaderShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        className: "page-layout-header py-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $0f76b278a70c1e69$export$6e8e699acb89c2ad), null)), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Navigate), {
        to: "/login",
        state: {
            from: location.pathname
        },
        replace: true
    });
};
const $493a928b246bcebc$var$App = ()=>{
    const sessionStatus = (0, $9MNgB.usePortalSession)();
    const location = (0, $gCMx8.useLocation)();
    (0, $jGnJo.useLayoutEffect)(()=>{
        // Scroll to the top of the page when the route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Routes), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "/*",
        element: sessionStatus === "loading" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8UPmf.PortalSessionLoader), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Navigate), {
            to: sessionStatus === "authenticated" ? "/dashboard" : "/login"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "login",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $4Mpw9.SignInPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "reset-password",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Qy4z.PasswordResetPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "user-agreement",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $3696a0d4ee907942$export$5573dc5ce5740818), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "reset-password-request",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $f3Zjn.ResetPasswordRequestPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "reset-password-request-success",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $8JDp9.ResetPasswordRequestSuccessPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "reset-password-request-error",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6jyTD.ResetPasswordRequestErrorPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "register-user",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6fbde30acf054b99$export$265471dcab9022d3), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "dashboard",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($493a928b246bcebc$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $ff0438a390809e1d$export$ab6746011d315456), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "registerchargepoint",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($493a928b246bcebc$var$RequireAuth, {
            isHeaderShown: false,
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6c5d853802269792$export$4a4cbf17073b70ff), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "remotecontrol",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($493a928b246bcebc$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $b04f289a0c2e8dcb$export$31f6100da20592ef), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "remotecontrol/:chargePointId/schedule",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($493a928b246bcebc$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $13ebc6589c81ffff$export$a4bf597a1fb62466), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "user-profile",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($493a928b246bcebc$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $b1d338bb17cffa87$export$3bf6356b6e1d6999), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "support",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($493a928b246bcebc$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $16e8a7738846a334$export$612b9760953b2c71), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5Lxn9.Route), {
        path: "statistics",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($493a928b246bcebc$var$RequireAuth, {
            sessionStatus: sessionStatus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $38369ead53bd3aff$export$bacd47cfcd142d32), null))
    }));
};
var $493a928b246bcebc$export$2e2bcd8739ae039 = $493a928b246bcebc$var$App;


(0, $iD0nF.initAuthChangeListener)();
const $7dee03d1bba6f564$var$root = (0, $gOtN5.createRoot)(document.getElementById("root"));
$7dee03d1bba6f564$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $9VxWA.ThemeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $jGnJo.Suspense), {
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", null)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fuAgC.LocalizationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $e19ko.Provider), {
    store: (0, $628b115dc3c73abd$export$6f57813fe9f31bf9)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $bvuBe.PrimeReactProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $4wzzF.ToastProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCMx8.BrowserRouter), {
    basename: "userapp"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $493a928b246bcebc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $7CxMf.ConfirmDialog), null)))))))));

})();
//# sourceMappingURL=index.060f35d7.js.map
